// Central localization dictionary. Add new languages by adding a top-level key.
export const translations = {
  es: {
    brand: { tagline: "La persona adecuada para lo que necesitas hoy." },
    langgate: {
      title: "Elige tu idioma",
      subtitle: "ConQuién Hoy está disponible en English, Español y አማርኛ.",
      default: "Predeterminado",
    },
    nav: {
      home: "Inicio",
      find: "Encontrar un profesional",
      psychologists: "Buscar profesional",
      initiatives: "Iniciativas",
      opportunities: "Oportunidades",
      join: "Ofrecer mis servicios",
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
      account: "Mi cuenta",
      admin: "Administración",
      organizer: "Organizador",
      workspace: "Mi espacio",
    },
    common: {
      loading: "Cargando…",
      search: "Buscar",
      clear: "Limpiar",
      filters: "Filtros",
      all: "Todos",
      save: "Guardar",
      cancel: "Cancelar",
      submit: "Enviar",
      back: "Volver",
      edit: "Editar",
      delete: "Eliminar",
      close: "Cerrar",
      confirm: "Confirmar",
      decline: "Rechazar",
      approve: "Aprobar",
      reject: "Rechazar",
      view: "Ver",
      online: "En línea",
      in_person: "Presencial",
      both: "Ambos",
      any: "Cualquiera",
      hybrid: "Híbrido",
      paid: "De pago",
      volunteer: "Voluntario / gratuito",
      language: "Idioma",
      country: "País",
      city: "Ciudad",
      optional: "opcional",
      required: "obligatorio",
      status: "Estado",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre completo",
      phone: "Teléfono",
      saving: "Guardando…",
      none: "Ninguno",
      not_provided: "Sin especificar",
      yes: "Sí",
      no: "No",
      share: "Compartir",
      copy_link: "Copiar enlace",
      link_copied: "Enlace copiado al portapapeles",
    },
    status: {
      pending: "Pendiente de revisión",
      changes: "Cambios solicitados",
      verified: "Verificado",
      rejected: "Rechazado",
      suspended: "Suspendido",
      draft: "Borrador",
      published: "Publicada",
      closed: "Cerrada",
      confirmed: "Confirmado",
      declined: "Rechazado",
      approved: "Aprobado",
      restricted: "Restringido",
    },
    home: {
      hero_sub: "ConQuién Hoy te ayuda a encontrar a la persona adecuada para lo que necesitas hoy: apoyo emocional o psicológico, coaching, comunicación, orientación profesional, mentoría de negocios y más. Conecta con profesionales verificados o revisados a través de las herramientas que ya utilizan.",
      cta_find: "Encontrar un profesional",
      cta_join: "Quiero ofrecer mis servicios",
      how_title: "Cómo funciona",
      how_sub: "Tres pasos sencillos para acercar la distancia.",
      step1_title: "Encontrar",
      step1_desc: "Descubre profesionales según las preferencias que más te importan.",
      step2_title: "Conectar",
      step2_desc: "Revisa su información, disponibilidad y métodos de conexión disponibles.",
      step3_title: "Hablar",
      step3_desc: "Continúa por el método de comunicación o agenda que ofrece el profesional.",
      initiatives_title: "Iniciativas de apoyo",
      initiatives_desc: "ConQuién Hoy también conecta a profesionales con iniciativas de apoyo organizadas.",
      initiatives_cta: "Ver iniciativas",
      trust_title: "Una plataforma que acerca personas",
      trust_desc: "Los profesionales independientes ofrecen los servicios. ConQuién Hoy facilita el encuentro.",
    },
    find: {
      title: "Encontrar un profesional",
      subtitle: "Busca profesionales verificados —psicología, coaching y más— sin necesidad de crear una cuenta.",
      results: "profesionales encontrados",
      result: "profesional encontrado",
      f_language: "Idioma",
      f_profession: "Profesión",
      f_category: "Categoría",
      f_works_with: "Trabaja con",
      f_engagement: "Tipo de trabajo",
      f_experience: "Experiencia mínima",
      f_gender: "Género",
      f_origin: "País de origen",
      f_culture: "Origen cultural",
      years: "años",
      intent_q: "¿Qué buscas hoy?",
      profession_q: "¿Qué tipo de profesional buscas?",
      guided_label: "Descubrimiento guiado",
      direct_label: "Buscar directamente",
      direct_hint: "¿Ya sabes a quién necesitas? Busca y filtra profesionales directamente.",
      f_country: "País",
      f_city: "Ciudad",
      f_area: "Área de apoyo",
      f_online: "En línea",
      f_in_person: "Presencial",
      f_paid: "De pago",
      f_volunteer: "Voluntario / gratuito",
      city_placeholder: "Escribe una ciudad",
      f_population: "Población atendida",
      f_approach: "Enfoque terapéutico",
      f_accepting: "Acepta nuevos clientes",
      f_insurance: "Trabaja con seguros",
      f_verified_only: "Solo credenciales verificadas",
      empty_title: "Aún no hay profesionales que coincidan",
      empty_desc: "No encontramos profesionales con estos criterios. Prueba ampliando tu búsqueda.",
      advanced: "Filtros avanzados",
    },
    directory: {
      title: "Directorio de profesionales",
      subtitle: "Explora los profesionales verificados disponibles en ConQuién Hoy.",
      empty_title: "Todavía no hay profesionales publicados",
      empty_desc: "El directorio aún está creciendo. Vuelve pronto o invita a profesionales a unirse.",
    },
    profile: {
      about: "Acerca de",
      areas: "Áreas de apoyo",
      credentials: "Credenciales profesionales",
      qualification: "Titulación profesional",
      profession: "Profesión",
      clinical: "Clínico / con licencia",
      non_clinical: "No clínico",
      not_verified: "Credenciales no verificadas por la plataforma",
      capabilities: "Capacidades",
      works_with: "Trabajo con",
      ways_i_work: "Formas de trabajo",
      experience: "Años de experiencia",
      license: "Número de registro / licencia",
      license_org: "Organización que registra / licencia",
      license_country: "País de registro profesional",
      service_format: "Modalidad de servicio",
      service_type: "Tipo de servicio",
      availability: "Disponibilidad",
      initiatives: "Iniciativas",
      available_initiatives: "Disponible para iniciativas de apoyo organizadas",
      not_available_initiatives: "No disponible para iniciativas en este momento",
      connect: "Conectar",
      email_cta: "Email",
      connect_primary: "Conectar ahora",
      other_methods: "Otros métodos de conexión",
      connect_note: "Este enlace abre una herramienta externa gestionada por el profesional.",
      no_bio: "Este profesional aún no ha añadido una biografía.",
      verified_note: "Verificado por ConQuién Hoy",
      verified_desc: "Hemos revisado la información y las credenciales que este profesional aportó. No otorgamos licencias ni garantizamos resultados.",
      book_appointment: "Reservar una cita",
      not_verified_note: "Información proporcionada por el profesional",
      populations: "Población atendida",
      approach: "Enfoque terapéutico",
      accepting_new: "Aceptando nuevos clientes",
      not_accepting: "No acepta nuevos clientes por ahora",
      payment: "Métodos de pago",
      insurance: "Seguros / cobertura de salud",
      works_insurance: "Trabaja con seguros o cobertura de salud",
      no_insurance: "No trabaja con seguros",
      payment_note: "Información proporcionada por el profesional. ConQuién Hoy no procesa pagos ni gestiona seguros; cualquier acuerdo económico es directamente con el profesional.",
      links: "Enlaces profesionales",
      leaving_site: "Vas a salir de ConQuién Hoy hacia un sitio externo.",
      share_title: "Compartir perfil",
      share_desc: "Copia el enlace público de este perfil para compartirlo.",
      professional_fallback: "Profesional",
      specialties: "Especialidades",
      languages_taught: "Idiomas que enseña",
      qualifications: "Cualificaciones",
      not_available_title: "Perfil no disponible",
      not_available_desc: "Este perfil profesional no existe o aún no está publicado.",
      back_to_directory: "Volver al directorio",
      payment_note_generic: "Información proporcionada por el profesional. ConQuién Hoy no procesa pagos; cualquier acuerdo económico es directamente con el profesional.",
      invite_opportunity: "Invitar a una oportunidad",
    },
    initiatives: {
      title: "Iniciativas de apoyo",
      subtitle: "Esfuerzos organizados donde los profesionales ponen su tiempo a disposición.",
      description: "Descripción",
      is_opportunity_label: "Es una oportunidad profesional",
      category_sought: "Categoría profesional buscada",
      specialty_optional: "Especialidad (opcional)",
      empty_title: "Todavía no hay iniciativas",
      empty_desc: "Cuando se publiquen iniciativas de apoyo, aparecerán aquí.",
      goal: "Meta de participación",
      applicants: "Solicitantes",
      confirmed: "Confirmados",
      remaining: "Plazas restantes",
      languages_needed: "Idiomas necesarios",
      requirements: "Requisitos profesionales",
      organizer: "Organizador",
      location: "Ubicación",
      dates: "Fechas",
      participate: "Solicitar participación",
      participate_desc: "Solo pedimos información específica de esta iniciativa.",
      p_availability: "Tu disponibilidad general",
      p_dates: "Fechas en las que puedes participar",
      p_format: "Disponibilidad en línea / presencial",
      p_notes: "Notas para el organizador",
      request_sent: "Tu solicitud de participación ha sido enviada.",
      already_joined: "Ya has solicitado participar en esta iniciativa.",
      login_to_join: "Inicia sesión como profesional para participar.",
      need_profile: "Necesitas un perfil profesional para participar. Te guiaremos por el registro.",
      no_participants: "Todavía no hay solicitudes de participación.",
      requires_online: "Requiere disponibilidad en línea",
      requires_in_person: "Requiere disponibilidad presencial",
      format_label_display: "Modalidad",
      online_and_in_person: "En línea y presencial",
      participation_closed: "La participación en esta iniciativa está cerrada.",
      not_published: "Esta iniciativa aún no está abierta a participación.",
      how_to_join: "¿Cómo participar?",
      share_initiative: "Compartir iniciativa",
      share_whatsapp: "WhatsApp",
      share_email: "Correo electrónico",
      share_email_subject: "Iniciativa en ConQuién Hoy",
      share_email_intro: "Te comparto esta iniciativa de ConQuién Hoy",
      share_native: "Compartir…",
      add_to_calendar: "Agregar al calendario",
      request_pending: "Tu solicitud está en revisión.",
      request_confirmed: "¡Estás confirmado/a para participar en esta iniciativa!",
      request_declined: "Tu solicitud no fue seleccionada esta vez.",
      full_badge: "Iniciativa completa",
      full_short: "Completa",
      full_note: "Esta iniciativa ha alcanzado su meta de participación.",
      reminder_text: "Ya estás de vuelta. Completa tu solicitud para participar en esta iniciativa.",
      joined_singular: "profesional ya se ha unido",
      joined_plural: "profesionales ya se han unido",
      filters: "Filtros",
      search_placeholder: "Buscar iniciativas…",
      f_location: "País o ubicación",
      f_language: "Idioma necesario",
      f_status: "Estado",
      f_open: "Con cupos disponibles",
      f_date_from: "Desde",
      f_date_to: "Hasta",
      clear_filters: "Limpiar filtros",
      all_statuses: "Todos",
      no_match_title: "Ninguna iniciativa coincide",
      no_match_desc: "Ajusta o limpia los filtros para ver más iniciativas.",
      join_intro: "Únete a esta iniciativa como profesional.",
      cta_login: "Iniciar sesión",
      cta_create_profile: "Crear perfil profesional",
      cta_guest_note: "Inicia sesión o crea tu perfil profesional para solicitar tu participación.",
      pick_dates: "Seleccionar fecha(s)",
      single_day: "Un día",
      date_range: "Rango de fechas",
      clear_dates: "Borrar fechas",
      category: "Categoría",
      specialty: "Especialidad",
      spots_remaining_one: "{n} lugar disponible",
      spots_remaining_other: "{n} lugares disponibles",
    },
    opportunities: {
      title: "Oportunidades profesionales",
      subtitle: "Descubre oportunidades profesionales abiertas publicadas por organizaciones.",
      badge: "Oportunidad profesional",
      empty_title: "Todavía no hay oportunidades abiertas",
      empty_desc: "Cuando las organizaciones publiquen oportunidades profesionales, aparecerán aquí.",
      no_match_title: "Ninguna oportunidad coincide",
      no_match_desc: "Ajusta o limpia los filtros para ver más oportunidades.",
      search_placeholder: "Buscar oportunidades…",
      filters: "Filtros",
      advanced: "Filtros avanzados",
      clear_filters: "Limpiar filtros",
      view_details: "Ver detalles",
      results: "oportunidades",
      result: "oportunidad",
      open_status: "Abierta",
      closed_status: "Cerrada",
      full_status: "Cupos completos",
      deadline_passed: "Plazo cerrado",
      f_profession: "Profesión requerida",
      f_language: "Idioma requerido",
      f_location: "País o ubicación",
      f_modality: "Modalidad",
      f_engagement: "Tipo de trabajo",
      f_compensation: "Compensación",
      f_verified_required: "Requiere credenciales verificadas",
      f_experience: "Experiencia requerida",
      f_crisis: "Respuesta a crisis / desastres",
      f_group: "Trabajo grupal",
      f_training: "Formación / taller",
      f_organizational: "Experiencia organizacional",
      f_deadline_before: "Fecha límite hasta",
      f_open_only: "Solo oportunidades abiertas",
      section_about: "Sobre la oportunidad",
      section_org: "Organización",
      section_requirements: "Requisitos profesionales",
      section_engagement: "Detalles del trabajo",
      section_dates: "Fechas",
      section_location: "Ubicación y modalidad",
      section_compensation: "Compensación",
      required_profession: "Profesión requerida",
      required_languages: "Idiomas requeridos",
      engagement_type: "Tipo de trabajo",
      compensation_type: "Compensación",
      min_experience: "Experiencia mínima",
      professionals_needed: "Profesionales necesarios",
      application_deadline: "Fecha límite de postulación",
      verified_required: "Requiere credenciales verificadas",
      no_specific: "Sin requisitos específicos para esta oportunidad.",
      your_profile: "Comparación con tu perfil",
      met: "Cumples este requisito",
      not_met: "No cumples este requisito",
      compare_note: "Comparación informativa con tu perfil. La organización toma la decisión final.",
      profession_mismatch_title: "Tu profesión no coincide",
      profession_mismatch_desc: "Esta oportunidad requiere otra profesión, por lo que no puedes postularte.",
      apply: "Postularme",
      apply_intro: "Postúlate a esta oportunidad profesional.",
      applied_pending: "Tu postulación está en revisión.",
      applied_confirmed: "¡Has sido aceptado/a en esta oportunidad!",
      applied_declined: "Tu postulación no fue seleccionada esta vez.",
      years: "años",
      deadline_label: "Fecha límite",
      closed_note: "Esta oportunidad ya no acepta postulaciones.",
      req_languages_field: "Idiomas requeridos",
      deadline_field: "Fecha límite de postulación",
    },
    inbox: {
      nav: "Bandeja de entrada",
      title_prof: "Consultas recibidas",
      title_org: "Consultas enviadas",
      empty_prof: "Aún no has recibido consultas de organizaciones.",
      empty_org: "Aún no has enviado consultas a profesionales.",
      sent_on: "Enviada",
      contact: "Contacto",
      location: "Ubicación",
      modality: "Modalidad",
      timeframe: "Fecha o periodo",
      language: "Idioma",
      note: "Nota",
      optional_note: "Nota opcional",
      note_placeholder: "Estoy interesado/a. Por favor, contáctame para hablar sobre disponibilidad y alcance.",
      interested: "Me interesa",
      decline: "Rechazar",
      close_inquiry: "Cerrar consulta",
      view_opportunity: "Ver oportunidad",
      responded: "Tu respuesta",
      interested_sent: "Respuesta enviada",
      closed_toast: "Consulta cerrada",
      closed_by_org: "La organización cerró esta consulta.",
      do_not_share: "No compartas información clínica confidencial ni datos de pacientes.",
      st_new: "Nueva",
      st_viewed: "Vista",
      st_interested: "Interesado/a",
      st_declined: "Rechazada",
      st_closed: "Cerrada",
    },
    join: {
      title: "Únete como profesional",
      subtitle: "Crea tu perfil profesional. Recopilamos solo lo necesario para evaluarlo.",
      section_personal: "Información personal",
      section_profession: "Profesión y categoría",
      profession: "Profesión",
      years_experience: "Años de experiencia",
      profession_other: "Especifica tu profesión",
      tag_clinical: "Profesional clínico / con licencia",
      tag_non_clinical: "Profesional no clínico",
      profession_note: "Tu profesión y categoría se muestran claramente en tu perfil. No presentamos a profesionales no clínicos como profesionales de la salud.",
      section_capabilities: "Capacidades profesionales",
      works_with: "Trabajo con",
      engagement_types: "Formas de trabajo",
      section_fit: "Afinidad (opcional, autodeclarado)",
      fit_note: "Estos campos son opcionales y autodeclarados. Ayudan a quienes buscan afinidad cultural o de idioma.",
      gender: "Género",
      country_of_origin: "País de origen",
      cultural_background: "Origen cultural",
      service_languages: "Idiomas de atención",
      countries_served: "Países que atiendo",
      section_professional: "Información profesional",
      section_format: "Modalidad y tipo de servicio",
      section_initiatives: "Disponibilidad para iniciativas",
      section_connection: "Métodos de conexión",
      photo: "Foto de perfil",
      upload_photo: "Subir foto",
      change_photo: "Cambiar foto",
      title_field: "Título profesional",
      areas_field: "Áreas de práctica o experiencia",
      bio_field: "Biografía profesional",
      bio_placeholder: "Cuéntanos sobre tu experiencia y tu enfoque…",
      format_label: "¿Cómo ofreces tus servicios?",
      type_label: "¿Tipo de servicio?",
      initiatives_label: "Estoy disponible para participar en iniciativas de apoyo organizadas",
      add_connection: "Añadir método de conexión",
      connection_type: "Tipo",
      connection_url: "Enlace (URL)",
      primary_method: "Método principal",
      set_primary: "Marcar como principal",
      submit_profile: "Enviar para revisión",
      section_populations: "Población y enfoque",
      populations_label: "¿Con qué poblaciones trabajas?",
      approach_label: "Enfoque terapéutico principal",
      accepting_label: "Actualmente estoy disponible para nuevas solicitudes",
      section_payment: "Pago y seguros",
      payment_label: "Métodos de pago aceptados",
      insurance_toggle: "Trabajo con seguros o cobertura de salud",
      insurance_field: "Detalles de seguros / cobertura",
      insurance_placeholder: "Indica con qué seguros o sistemas de cobertura trabajas…",
      payment_disclaimer: "Esta información es solo informativa. ConQuién Hoy no cobra pagos, no procesa seguros ni gestiona la facturación.",
      section_links: "Enlaces profesionales",
      links_label: "Enlaces profesionales o redes",
      link_type: "Tipo",
      add_link: "Añadir enlace",
      section_contact_form: "Formulario de contacto",
      enable_contact_form: "Activar un formulario de contacto simple en mi perfil",
      contact_email_label: "Correo para recibir mensajes de contacto",
      contact_email_placeholder: "correo@ejemplo.com",
      contact_form_hint: "Los mensajes son solo una presentación inicial. No solicites ni compartas información médica.",
      pending_title: "Perfil enviado — Pendiente de revisión",
      pending_desc: "Gracias. Un administrador de ConQuién Hoy revisará tu perfil antes de publicarlo. Los perfiles no se hacen públicos automáticamente.",
      go_workspace: "Ir a mi espacio",
      select_areas: "Selecciona tus áreas",
    },
    onboarding: {
      title: "Crea tu perfil profesional",
      subtitle: "Guardamos tu progreso automáticamente. Puedes salir y volver cuando quieras.",
      contact_title: "Información de contacto",
      contact_email_label: "Email de contacto",
      contact_email_hint: "Obligatorio. Puede ser distinto al email de tu cuenta.",
      use_contact_form: "Recibir mensajes mediante un formulario (tu email no se mostrará públicamente)",
      phone_label: "Teléfono (opcional)",
      phone_hint: "Incluye el código de país. Ej.: +57 300 123 4567",
      phone_public_label: "Mostrar mi número de teléfono públicamente",
      phone_public_hint: "Desactivado por defecto. Si lo activas, tu teléfono aparecerá en tu perfil público.",
      other_country_label: "Otro país",
      other_country_placeholder: "Busca y añade un país…",
      other_country_hint: "Selecciona de la lista para añadir más países que atiendes.",
      links_title: "Enlaces (opcional)",
      website_label: "Sitio web",
      booking_label: "Enlace de reservas",
      booking_hint: "Enlace externo de agenda si ya usas otro servicio.",
      video_label: "Enlace de videollamada",
      availability_notes_label: "Notas sobre disponibilidad (opcional)",
      availability_notes_hint: "Información adicional que quieras compartir sobre tu disponibilidad.",
      go_workspace: "Ir a mi espacio",
      stage_account: "Cuenta",
      stage_identity: "Identidad profesional",
      stage_experience: "Experiencia y enfoque",
      stage_services: "Servicios y capacidades",
      stage_profile: "Perfil",
      stage_availability: "Disponibilidad",
      stage_review: "Revisión",
      stage_submitted: "Enviado",
      step_of: "Paso {n} de {total}",
      save_continue: "Guardar y continuar",
      save_exit: "Guardar y salir",
      back: "Atrás",
      draft_saved: "Borrador guardado",
      save_error: "No se pudo guardar. Inténtalo de nuevo.",
      choose_profession: "¿Cuál es tu profesión?",
      choose_profession_hint: "Elige la opción que mejor te describe. Se mostrará claramente en tu perfil.",
      account_intro: "Datos básicos de contacto y ubicación.",
      identity_intro: "Tu profesión, título y credenciales.",
      credentials: "Credenciales profesionales",
      credentials_hint: "Como profesional clínico, necesitamos tu información de licencia para verificarte.",
      credential_type: "Tipo de credencial / colegiación",
      review_title: "Revisa tu perfil antes de enviarlo",
      review_intro: "Comprueba que todo esté correcto. Puedes editar cualquier sección.",
      incomplete_title: "Faltan algunos datos obligatorios",
      incomplete_desc: "Completa los campos marcados para poder enviar tu perfil a revisión.",
      submit: "Enviar para revisión",
      resubmit: "Volver a enviar para revisión",
      not_provided: "Sin especificar",
      submitted_title: "¡Perfil enviado! — Pendiente de revisión",
      submitted_desc: "Gracias. Un administrador de ConQuién Hoy revisará tu perfil antes de publicarlo. Recibirás un correo cuando cambie su estado.",
      resubmitted_desc: "Gracias. Hemos recibido tus cambios y tu perfil está de nuevo pendiente de revisión.",
      missing_full_name: "Nombre completo",
      missing_profession: "Profesión",
      missing_profession_other: "Especifica tu profesión",
      missing_country: "País",
      missing_bio: "Biografía profesional",
      missing_years_experience: "Años de experiencia",
      missing_languages: "Idiomas",
      missing_engagement_types: "Formas de trabajo",
      missing_connection_methods: "Al menos un método de conexión",
      missing_license_number: "Número de licencia",
      missing_license_org: "Organismo emisor",
      missing_license_country: "País de la licencia",
      missing_expertise: "Áreas de especialización",
      missing_who: "¿Con quién trabajas?",
      missing_services: "¿Cómo trabajas?",
      missing_populations_served: "Poblaciones",
      missing_service_languages: "Idiomas que enseñas",
      missing_contact_email: "Email de contacto",
      category_label: "Categoría profesional",
      category_hint: "Elige el área que mejor describe tu trabajo.",
      profession_public_note: "Tu profesión y especialidades se muestran en tu perfil público.",
      qual_placeholder: "Certificaciones, formación o experiencia relevante…",
      qual_note: "Comparte tus cualificaciones relevantes — no se tratan como una licencia clínica.",
      languages_you_teach: "Idiomas que enseñas",
      specialties_label: "Especialidades / capacidades",
      specialties_hint: "¿Con qué puedes ayudar a alguien?",
      specialty_add_placeholder: "Añadir una especialidad…",
      add_btn: "Añadir",
      payment_info_note: "Esta información es solo informativa. ConQuién Hoy no gestiona pagos ni facturación.",
      no_matches: "Sin resultados",
    },
    booking: {
      book_cta: "Reservar cita",
      agenda: "Agenda",
      my_appts: "Mis citas",
      upcoming: "Próximas",
      past: "Pasadas",
      settings: "Configuración de reservas",
      appointments: "Citas",
      availability: "Disponibilidad",
      client: "Cliente",
      reschedule: "Reprogramar",
      reschedule_title: "Reprogramar cita",
      choose_new_time: "Elige un nuevo horario",
      no_slots: "No hay horarios disponibles ese día.",
      rescheduled_ok: "Cita reprogramada",
      reschedule_err: "No se pudo reprogramar",
      confirm_new_time: "Confirmar nuevo horario",
      mark_completed: "Completada",
      mark_no_show: "No asistió",
      status_updated: "Estado actualizado",
      account: "Mi cuenta",
      account_settings: "Ajustes de cuenta",
      account_desc: "Gestiona tu zona horaria y cómo quieres recibir avisos.",
      your_timezone: "Tu zona horaria",
      phone: "Teléfono (opcional)",
      notif_prefs: "Preferencias de notificación",
      notif_email: "Correo electrónico",
      notif_inapp: "En la aplicación",
      notif_whatsapp: "WhatsApp (próximamente)",
      whatsapp_note: "Activa WhatsApp para recibir recordatorios por este medio cuando esté disponible.",
      settings_saved: "Ajustes guardados",
      settings_err: "No se pudieron guardar los ajustes",
      no_appts_psy: "No tienes citas todavía",
      reminders_note: "Los recordatorios se envían automáticamente 24 h y 3 h antes.",
      status_accepting: "Aceptando citas",
      status_limited: "Disponibilidad limitada",
      status_not_accepting: "No acepta citas actualmente",
      reminder_preview_title: "Qué recibirás",
      reminder_email_title: "Correo electrónico",
      reminder_email_24: "24 horas antes de tu cita",
      reminder_email_3: "3 horas antes de tu cita",
      reminder_email_off: "No recibirás recordatorios por correo",
      reminder_inapp_title: "En la aplicación",
      reminder_inapp_desc: "Actualizaciones de citas y agenda en Mis citas",
      reminder_inapp_off: "Sin actualizaciones en la aplicación",
      no_slots_hint: "Solo puedes elegir días con horarios disponibles.",
      confirm_cancel: "¿Cancelar esta cita?",
      cancelled_ok: "Cita cancelada",
      cancel_err: "No se pudo cancelar",
      update_err: "No se pudo actualizar",
      add_appt: "Agregar cita",
      manual_tag: "Manual",
      st_confirmed: "Confirmada",
      st_cancelled: "Cancelada",
      st_completed: "Completada",
      st_no_show: "No asistió",
      st_rescheduled: "Reprogramada",
      enter_client_name: "Ingresa el nombre del cliente",
      choose_date_time: "Elige fecha y hora",
      invalid_duration: "Duración inválida",
      appt_rescheduled: "Cita reprogramada",
      appt_added: "Cita agregada a tu agenda",
      save_appt_err: "No se pudo guardar la cita",
      reschedule_appt: "Reprogramar cita",
      choose_new_date_time: "Elige la nueva fecha y hora.",
      manual_desc: "Registra una cita para un cliente que atiendes fuera de la plataforma. No necesita cuenta.",
      client_name: "Nombre del cliente",
      client_name_ph: "Ej. Cliente de ejemplo",
      date: "Fecha",
      start_time: "Hora de inicio",
      duration_min: "Duración (minutos)",
      type_title_opt: "Tipo / título (opcional)",
      type_title_ph: "Ej. Sesión de seguimiento",
      private_note_opt: "Nota privada (opcional)",
      private_note_ph: "Solo tú puedes ver esto",
      client_email_opt: "Correo del cliente (opcional)",
      email_will_send: "Se enviará confirmación y recordatorios al cliente.",
      email_internal: "Sin correo, la cita es solo interna (sin avisos al cliente).",
      email_language: "Idioma del correo",
      email_lang_note: "El cliente recibirá los correos en este idioma.",
      save_changes: "Guardar cambios",
      booked_ok: "¡Cita reservada!",
      slot_unavailable: "Ese horario ya no está disponible",
      appt_type: "Tipo de cita",
      modality: "Modalidad",
      choose_date: "Elige una fecha",
      your_local_time: "Tu hora local",
      no_times_day: "No hay horarios disponibles ese día.",
      continue: "Continuar",
      professional_time: "Hora del profesional",
      confirm_booking: "Confirmar reserva",
      pick_time_again: "Vuelve a elegir un horario.",
      back: "Volver",
      appt_confirmed: "Tu cita está confirmada.",
      confirmation_email_sent: "Te enviamos un correo de confirmación.",
      create_account: "Crear cuenta",
      sign_in: "Iniciar sesión",
      account_needed: "Necesitas una cuenta para reservar. No pedimos información clínica.",
      full_name: "Nombre completo",
      email: "Correo",
      password: "Contraseña",
      phone_opt: "Teléfono (opcional)",
      tz_autodetect: "Detectada automáticamente — confírmala.",
      create_continue: "Crear cuenta y continuar",
      current: "Actual",
      no_appts_client: "No tienes citas aquí",
      find_professional: "Encontrar profesional",
      add_to_calendar: "Agregar al calendario",
      book_again: "Reservar otra cita",
      enable_booking: "Activar reservas en mi perfil",
      avail_tz_note: "Tu disponibilidad se define en tu hora local.",
      weekly_avail: "Disponibilidad semanal",
      unavailable: "No disponible",
      appt_types: "Tipos de cita",
      add: "Añadir",
      buffer_before: "Margen antes (min)",
      buffer_after: "Margen después (min)",
      min_notice: "Antelación mínima (horas)",
      booking_horizon: "Ventana de reserva (días)",
      blocked_dates: "Fechas bloqueadas",
      all_day: "Todo el día",
      internal_note_priv: "Nota interna (privada)",
      type_label_ph: "Etiqueta (ej. Consulta)",
      default_short: "Predet.",
      location_inperson: "Ubicación (presencial)",
      online_info: "Información de sesión online",
      cancel_policy_opt: "Política de cancelación (opcional)",
      advance_reminder: "Recordatorio anticipado",
      sameday_reminder: "Recordatorio el mismo día",
      cal_event_title: "Cita con",
      days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
    },
    contact: {
      title: "Enviar un mensaje",      desc: "Preséntate brevemente. Este formulario es solo para un primer contacto.",
      notice: "No incluyas información médica, diagnósticos, historiales clínicos, datos de emergencia ni información sensible de salud.",
      name: "Tu nombre",
      email: "Tu correo electrónico",
      message: "Mensaje breve",
      send: "Enviar mensaje",
      sending: "Enviando…",
      sent: "Tu mensaje ha sido enviado.",
      error: "No se pudo enviar el mensaje. Inténtalo de nuevo.",
    },
    auth: {
      login_title: "Iniciar sesión",
      register_title: "Crear cuenta",
      no_account: "¿No tienes cuenta?",
      have_account: "¿Ya tienes cuenta?",
      register_here: "Regístrate aquí",
      login_here: "Inicia sesión",
      role_label: "Quiero registrarme como",
      role_psychologist: "Psicólogo/a",
      role_organizer: "Organizador/a",
      accept_terms_pre: "He leído y acepto los",
      terms_link: "Términos de Uso",
      and: "y la",
      privacy_link: "Política de Privacidad",
      login_btn: "Entrar",
      register_btn: "Crear cuenta",
      logging_in: "Entrando…",
      creating: "Creando cuenta…",
      organizer_pending: "Tu cuenta de organizador está pendiente de aprobación por un administrador.",
      forgot: "¿Olvidaste tu contraseña?",
      choose_participation: "Elige cómo quieres participar.",
      register_professional_title: "Crear cuenta profesional",
      register_org_title: "Crear cuenta de organización",
      register_client_title: "Crear tu cuenta",
      participate_q: "¿Cómo quieres participar en ConQuién Hoy?",
      participate_client: "Busco a alguien para hablar",
      participate_professional: "Quiero ofrecer mis servicios",
      participate_org: "Represento a una organización",
    },
    forgot: {
      title: "Recuperar contraseña",
      subtitle: "Introduce tu correo y te enviaremos instrucciones para restablecer tu contraseña.",
      submit: "Enviar instrucciones",
      confirmation: "Si existe una cuenta para ese correo, hemos enviado instrucciones para restablecer la contraseña. Revisa tu bandeja de entrada.",
    },
    reset: {
      title: "Restablecer contraseña",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar nueva contraseña",
      hint: "Mínimo 8 caracteres, con letras y números.",
      submit: "Cambiar contraseña",
      success: "Contraseña restablecida. Ya puedes iniciar sesión.",
      mismatch: "Las contraseñas no coinciden.",
      invalid: "El enlace de restablecimiento no es válido o ha caducado.",
    },
    workspace: {
      title: "Mi espacio",
      profile: "Mi perfil",
      links: "Mis enlaces",
      initiatives: "Mis iniciativas",
      availability: "Disponibilidad",
      no_profile_title: "Aún no has creado tu perfil",
      no_profile_desc: "Crea tu perfil profesional para aparecer en el directorio tras la revisión.",
      create_profile: "Crear mi perfil",
      status_pending: "Tu perfil está pendiente de revisión por un administrador.",
      status_verified: "Tu perfil está verificado y visible en el directorio.",
      status_rejected: "Tu perfil no fue aprobado. Puedes editarlo y volver a enviarlo.",
      status_suspended: "Tu perfil ha sido suspendido. Contacta con la administración.",
      no_initiatives: "Aún no participas en ninguna iniciativa.",
      view_initiative: "Ver iniciativa",
      participations_all: "Todas",
      participations_initiatives: "Iniciativas",
      participations_opportunities: "Oportunidades",
      profile_saved: "Perfil guardado correctamente.",
      links_saved: "Enlaces actualizados.",
      changes_banner_title: "Se necesitan algunos cambios antes de continuar.",
      update_profile: "Actualizar perfil",
      resubmit: "Volver a enviar para revisión",
      status_changes: "Un administrador ha solicitado cambios en tu perfil. Revísalos, actualiza tu información y vuelve a enviarlo.",
      settings: "Configuración",
      status_draft: "Tu perfil es un borrador. Continúa donde lo dejaste para enviarlo a revisión.",
      status_changes_short: "Cambios solicitados",
      draft_banner: "Termina tu registro para enviar tu perfil a revisión.",
      continue_onboarding: "Continuar registro",
      requested_changes_label: "Cambios solicitados:",
    },
    del: {
      section_title: "Zona de peligro",
      pro_button: "Eliminar perfil profesional",
      pro_desc: "Esto elimina tu perfil profesional, no tu cuenta de ConQuién Hoy. Tu inicio de sesión se conservará y podrás crear un nuevo perfil más adelante.",
      confirm_title: "¿Eliminar tu perfil profesional permanentemente?",
      confirm_body: "Tu perfil profesional dejará de estar disponible en ConQuién Hoy y se eliminarán los datos asociados que puedan eliminarse de forma segura. Esta acción no se puede deshacer.",
      cancel: "Cancelar",
      confirm_action: "Eliminar permanentemente",
      success: "Perfil profesional eliminado.",
      blocked_title: "No se puede eliminar por ahora",
      blocked_body: "Este perfil tiene actividad vinculada (citas, participaciones o mensajes) que debe conservarse. Para proteger el historial, el perfil no puede eliminarse permanentemente en este momento.",
      error: "No se pudo eliminar el perfil. Inténtalo de nuevo.",
      admin_button: "Eliminar perfil",
      admin_confirm_title: "¿Eliminar este perfil profesional permanentemente?",
      admin_confirm_body: "Se eliminarán el perfil y los datos asociados que puedan eliminarse de forma segura. La cuenta de acceso del usuario no se eliminará. Esta acción no se puede deshacer.",
      admin_success: "Perfil profesional eliminado.",
    },
    organizer: {
      title: "Panel de organizador",
      pending_account: "Tu cuenta de organizador está pendiente de aprobación. Podrás crear iniciativas una vez aprobada.",
      new_initiative: "Nueva iniciativa",
      my_initiatives: "Mis iniciativas",
      no_initiatives: "Aún no has creado ninguna iniciativa.",
      create_title: "Crear iniciativa",
      edit_title: "Editar iniciativa",
      name: "Nombre de la iniciativa",
      publish: "Publicar",
      unpublish: "Despublicar",
      close: "Cerrar iniciativa",
      participants: "Participantes",
      review_participants: "Revisar participantes",
      contact: "Contacto",
      no_participants: "Todavía no hay solicitudes de participación.",
      saved: "Iniciativa guardada.",
      dashboard_subtitle: "Gestiona tus iniciativas: comparte, recluta, revisa solicitudes y coordina a tu equipo.",
      open_workspace: "Abrir espacio",
      back_dashboard: "Volver al panel",
      overview: "Resumen",
      team: "Equipo",
      applicants_tab: "Solicitudes",
      availability_tab: "Disponibilidad",
      contacts_tab: "Contactos",
      notes_tab: "Notas",
      share_tab: "Compartir",
      quick_edit: "Editar iniciativa",
      team_roster: "Equipo de la iniciativa",
      filter_status: "Filtrar por estado",
      view_profile: "Ver perfil",
      no_team: "Todavía no hay profesionales en el equipo.",
      new_requests: "Nuevas solicitudes",
      confirmed_participants: "Participantes confirmados",
      availability_desc: "Vista rápida de la disponibilidad de los participantes confirmados.",
      no_availability: "Aún no hay participantes confirmados.",
      contacts_desc: "Información de contacto de los participantes confirmados. Visible solo para ti.",
      no_contacts: "Aún no hay participantes confirmados.",
      notes_title: "Notas de coordinación",
      notes_desc: "Espacio para información logística. No incluyas información clínica ni de pacientes.",
      add_note: "Añadir nota",
      note_placeholder: "Escribe una nota logística…",
      no_notes: "Todavía no hay notas.",
      share_title: "Enlace público de la iniciativa",
      share_desc: "Comparte este enlace por los canales que ya utilizas. Lleva a la página pública donde los profesionales pueden solicitar participar.",
      copy_link: "Copiar enlace",
      link_copied: "Enlace copiado al portapapeles",
      share_draft_note: "Esta iniciativa está en borrador. Publícala para que el enlace sea accesible públicamente.",
      reach_tab: "Alcance",
      reach_title: "Alcance de la iniciativa",
      reach_desc: "Actividad generada dentro de ConQuién Hoy para esta iniciativa. Datos agregados y anónimos.",
      reach_views: "Vistas de la página",
      reach_shares: "Usos de compartir",
      reach_copy: "Copiar enlace",
      reach_whatsapp: "WhatsApp",
      reach_email: "Correo",
      reach_requests: "Solicitudes de participación",
      reach_note: "Estas métricas solo reflejan la actividad dentro de ConQuién Hoy y nunca identifican a visitantes individuales.",
      visibility: "Visibilidad",
      org_profile_title: "Perfil de organización",
      org_profile_desc: "Necesario para invitar a profesionales a oportunidades.",
      org_profile_saved: "Perfil de organización guardado",
      org_profile_error: "No se pudo guardar",
      org_name_label: "Nombre de la organización",
      org_type_label: "Tipo",
      org_contact_label: "Persona de contacto",
      org_website_label: "Sitio web",
    },
    inquiry: {
      sent: "Invitación enviada",
      send_error: "No se pudo enviar",
      title: "Invitar a una oportunidad",
      desc: "Contactas a {name} en nombre de tu organización.",
      type_label: "Tipo de oportunidad",
      location: "Ubicación",
      modality: "Modalidad",
      hybrid: "Híbrido",
      timeframe: "Fecha o periodo",
      language_required: "Idioma requerido",
      warning: "No incluyas información clínica confidencial ni datos de pacientes.",
      submit: "Enviar invitación",
    },
    admin: {
      title: "Administración",
      psychologists: "Psicólogos",
      professionals: "Profesionales",
      organizers: "Organizadores",
      initiatives: "Iniciativas",
      areas: "Áreas de apoyo",
      pending: "Pendientes",
      verified: "Verificados",
      all: "Todos",
      stats_pending: "Profesionales pendientes",
      stats_verified: "Profesionales verificados",
      stats_org_pending: "Organizadores pendientes",
      stats_initiatives: "Iniciativas",
      suspend: "Suspender",
      restrict: "Restringir",
      area_es: "Nombre (ES)",
      area_en: "Nombre (EN)",
      add_area: "Añadir área",
      no_psychologists: "No hay profesionales en esta categoría.",
      all_professions: "Todas las profesiones",
      no_organizers: "Todavía no hay organizadores registrados.",
      security: "Seguridad",
      change_password: "Cambiar contraseña",
      current_password: "Contraseña actual",
      new_password: "Nueva contraseña",
      confirm_password: "Confirmar nueva contraseña",
      pw_hint: "Mínimo 8 caracteres, con letras y números.",
      pw_updated: "Contraseña actualizada correctamente.",
      pw_mismatch: "Las contraseñas no coinciden.",
      bookings: "Reservas",
      bk_search: "Buscar por cliente o profesional",
      bk_all_psych: "Todos los profesionales",
      bk_all_status: "Todos los estados",
      bk_all_modality: "Todas las modalidades",
      bk_from: "Desde",
      bk_to: "Hasta",
      bk_client: "Cliente",
      bk_psych: "Profesional",
      bk_when: "Fecha y hora",
      bk_status: "Estado",
      bk_modality: "Modalidad",
      bk_reminders: "Recordatorios",
      bk_none: "No hay reservas que coincidan.",
      bk_rescheduled: "reprogramación(es)",
      bk_clear: "Limpiar filtros",
      bk_note: "Vista operativa de solo lectura. No se almacena ni se muestra contenido clínico.",
      stat_awaiting_review: "Profesionales esperando revisión",
      open_review_queue: "Abrir cola de revisión →",
      all_categories: "Todas",
      credentials: "Credenciales",
      cred_type: "Tipo",
      cred_license: "Licencia",
      qualifications: "Cualificaciones y experiencia",
      years_short: "años",
      request_changes: "Solicitar cambios",
      note_prompt: "Nota para el profesional:",
      initiative_deleted: "Iniciativa eliminada",
      delete_initiative: "Eliminar iniciativa",
      delete_init_title: "¿Eliminar esta iniciativa permanentemente?",
      delete_init_body: "Se eliminarán permanentemente la iniciativa y sus registros de participación. La cuenta del organizador no se ve afectada. Esta acción no se puede deshacer.",
      bk_load_error: "No se pudieron cargar las reservas. Inténtalo de nuevo.",
      bk_st_confirmed: "Confirmada",
      bk_st_cancelled: "Cancelada",
      bk_st_completed: "Completada",
      bk_st_no_show: "No asistió",
      bk_st_rescheduled: "Reprogramada",
    },
    footer: {
      legal: "Legal",
      tagline: "Una plataforma para acercar personas.",
      owned: "Un proyecto de Alias Distribution LLC.",
      rights: "© 2026 Alias Distribution LLC. Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos de Uso",
      disclaimer: "Aviso Profesional y Médico",
      copyright: "Derechos de autor",
      disclaimer_short: "ConQuién Hoy es una plataforma de conexión y no ofrece terapia, consejo médico, diagnóstico, tratamiento ni servicios de emergencia. Los profesionales listados en ConQuién Hoy prestan sus servicios de forma independiente.",
    },
    emergency: {
      text: "ConQuién Hoy no es un servicio de emergencia. Si estás viviendo una emergencia, contacta con los servicios de emergencia disponibles en tu ubicación.",
    },
    legal: {
      privacy: "Política de Privacidad",
      terms: "Términos de Uso",
      disclaimer: "Aviso Profesional y Médico",
      copyright: "Derechos de Autor",
    },
    notfound: { title: "Página no encontrada", desc: "La página que buscas no existe.", home: "Volver al inicio" },
  },

  en: {
    brand: { tagline: "The right person for what you need today." },
    langgate: {
      title: "Choose your language",
      subtitle: "ConQuién Hoy is available in English, Español and አማርኛ.",
      default: "Default",
    },
    nav: {
      home: "Home",
      find: "Find a professional",
      psychologists: "Find a professional",
      initiatives: "Initiatives",
      opportunities: "Opportunities",
      join: "Offer my services",
      login: "Log in",
      logout: "Log out",
      account: "My account",
      admin: "Administration",
      organizer: "Organizer",
      workspace: "My workspace",
    },
    common: {
      loading: "Loading…",
      search: "Search",
      clear: "Clear",
      filters: "Filters",
      all: "All",
      save: "Save",
      cancel: "Cancel",
      submit: "Submit",
      back: "Back",
      edit: "Edit",
      delete: "Delete",
      close: "Close",
      confirm: "Confirm",
      decline: "Decline",
      approve: "Approve",
      reject: "Reject",
      view: "View",
      online: "Online",
      in_person: "In person",
      both: "Both",
      any: "Any",
      hybrid: "Hybrid",
      paid: "Paid",
      volunteer: "Volunteer / free",
      language: "Language",
      country: "Country",
      city: "City",
      optional: "optional",
      required: "required",
      status: "Status",
      email: "Email",
      password: "Password",
      name: "Full name",
      phone: "Phone",
      saving: "Saving…",
      none: "None",
      not_provided: "Not provided",
      yes: "Yes",
      no: "No",
      share: "Share",
      copy_link: "Copy link",
      link_copied: "Link copied to clipboard",
    },
    status: {
      pending: "Pending review",
      verified: "Verified",
      rejected: "Rejected",
      suspended: "Suspended",
      draft: "Draft",
      published: "Published",
      closed: "Closed",
      confirmed: "Confirmed",
      declined: "Declined",
      approved: "Approved",
      restricted: "Restricted",
    },
    home: {
      hero_sub: "ConQuién Hoy helps people find the right person for what they need today: emotional or psychological support, coaching, communication, career guidance, business mentorship and more. Connect with verified or reviewed professionals through the tools they already use.",
      cta_find: "Find a professional",
      cta_join: "I want to offer my services",
      how_title: "How it works",
      how_sub: "Three simple steps to close the distance.",
      step1_title: "Find",
      step1_desc: "Discover professionals according to the preferences that matter most to you.",
      step2_title: "Connect",
      step2_desc: "Review their information, availability and available connection methods.",
      step3_title: "Talk",
      step3_desc: "Continue through the communication or scheduling method the professional provides.",
      initiatives_title: "Support initiatives",
      initiatives_desc: "ConQuién Hoy also connects professionals with organized support initiatives.",
      initiatives_cta: "View initiatives",
      trust_title: "A platform that brings people together",
      trust_desc: "Independent professionals provide the services. ConQuién Hoy facilitates the connection.",
    },
    find: {
      title: "Find a professional",
      subtitle: "Search verified professionals —psychology, coaching and more— without creating an account.",
      results: "professionals found",
      result: "professional found",
      f_language: "Language",
      f_profession: "Profession",
      f_category: "Category",
      f_works_with: "Works with",
      f_engagement: "Engagement type",
      f_experience: "Minimum experience",
      f_gender: "Gender",
      f_origin: "Country of origin",
      f_culture: "Cultural background",
      years: "years",
      intent_q: "What are you looking for today?",
      profession_q: "What type of professional are you looking for?",
      guided_label: "Guided discovery",
      direct_label: "Search directly",
      direct_hint: "Already know who you need? Search and filter professionals directly.",
      f_country: "Country",
      f_city: "City",
      f_area: "Area of support",
      f_online: "Online",
      f_in_person: "In person",
      f_paid: "Paid",
      f_volunteer: "Volunteer / free",
      city_placeholder: "Type a city",
      f_population: "Population served",
      f_approach: "Therapeutic approach",
      f_accepting: "Accepting new clients",
      f_insurance: "Works with insurance",
      f_verified_only: "Verified credentials only",
      empty_title: "No professionals match yet",
      empty_desc: "We couldn't find professionals with these criteria. Try broadening your search.",
      advanced: "Advanced filters",
    },
    directory: {
      title: "Professional directory",
      subtitle: "Explore the verified professionals available on ConQuién Hoy.",
      empty_title: "No professionals published yet",
      empty_desc: "The directory is still growing. Check back soon or invite professionals to join.",
    },
    profile: {
      about: "About",
      areas: "Areas of support",
      credentials: "Professional credentials",
      qualification: "Professional qualification",
      profession: "Profession",
      clinical: "Clinical / licensed",
      non_clinical: "Non-clinical",
      not_verified: "Credentials not verified by the platform",
      capabilities: "Capabilities",
      works_with: "I work with",
      ways_i_work: "Ways I work",
      experience: "Years of experience",
      license: "Registration / license number",
      license_org: "Registering / licensing organization",
      license_country: "Country of professional registration",
      service_format: "Service format",
      service_type: "Service type",
      availability: "Availability",
      initiatives: "Initiatives",
      available_initiatives: "Available for organized support initiatives",
      not_available_initiatives: "Not available for initiatives at this time",
      connect: "Connect",
      email_cta: "Email",
      connect_primary: "Connect now",
      other_methods: "Other connection methods",
      connect_note: "This link opens an external tool managed by the professional.",
      no_bio: "This professional hasn't added a biography yet.",
      verified_note: "Verified by ConQuién Hoy",
      verified_desc: "We've reviewed the information and credentials this professional provided. We don't license professionals or guarantee outcomes.",
      book_appointment: "Book an appointment",
      not_verified_note: "Information provided by the professional",
      populations: "Population served",
      approach: "Therapeutic approach",
      accepting_new: "Accepting new clients",
      not_accepting: "Not accepting new clients right now",
      payment: "Payment methods",
      insurance: "Insurance / health coverage",
      works_insurance: "Works with insurance or health coverage",
      no_insurance: "Does not work with insurance",
      payment_note: "Information provided by the professional. ConQuién Hoy does not process payments or manage insurance; any financial arrangement is directly with the professional.",
      links: "Professional links",
      leaving_site: "You are leaving ConQuién Hoy to an external site.",
      share_title: "Share profile",
      share_desc: "Copy this profile's public link to share it.",
      professional_fallback: "Professional",
      specialties: "Specialties",
      languages_taught: "Languages taught",
      qualifications: "Qualifications",
      not_available_title: "Profile not available",
      not_available_desc: "This professional profile doesn't exist or isn't published yet.",
      back_to_directory: "Back to directory",
      payment_note_generic: "Information provided by the professional. ConQuién Hoy does not process payments; any financial arrangement is directly with the professional.",
      invite_opportunity: "Invite to an opportunity",
    },
    initiatives: {
      title: "Support initiatives",
      description: "Description",
      is_opportunity_label: "This is a professional opportunity",
      category_sought: "Professional category sought",
      specialty_optional: "Specialty (optional)",
      subtitle: "Organized efforts where professionals make their time available.",
      empty_title: "No initiatives yet",
      empty_desc: "When support initiatives are published, they will appear here.",
      goal: "Participation goal",
      applicants: "Applicants",
      confirmed: "Confirmed",
      remaining: "Spots remaining",
      languages_needed: "Languages needed",
      requirements: "Professional requirements",
      organizer: "Organizer",
      location: "Location",
      dates: "Dates",
      participate: "Request participation",
      participate_desc: "We only ask for information specific to this initiative.",
      p_availability: "Your general availability",
      p_dates: "Dates you can participate",
      p_format: "Online / in-person availability",
      p_notes: "Notes for the organizer",
      request_sent: "Your participation request has been sent.",
      already_joined: "You have already requested to participate in this initiative.",
      login_to_join: "Log in as a professional to participate.",
      need_profile: "You need a professional profile to participate. We'll guide you through registration.",
      no_participants: "No participation requests yet.",
      requires_online: "Requires online availability",
      requires_in_person: "Requires in-person availability",
      format_label_display: "Format",
      online_and_in_person: "Online and in person",
      participation_closed: "Participation in this initiative is closed.",
      not_published: "This initiative is not open for participation yet.",
      how_to_join: "How to participate",
      share_initiative: "Share initiative",
      share_whatsapp: "WhatsApp",
      share_email: "Email",
      share_email_subject: "An initiative on ConQuién Hoy",
      share_email_intro: "I'm sharing this ConQuién Hoy initiative with you",
      share_native: "Share…",
      add_to_calendar: "Add to calendar",
      request_pending: "Your request is under review.",
      request_confirmed: "You're confirmed to participate in this initiative!",
      request_declined: "Your request wasn't selected this time.",
      full_badge: "Initiative full",
      full_short: "Full",
      full_note: "This initiative has reached its participation goal.",
      reminder_text: "You're back. Complete your request to participate in this initiative.",
      joined_singular: "professional has already joined",
      joined_plural: "professionals have already joined",
      filters: "Filters",
      search_placeholder: "Search initiatives…",
      f_location: "Country or location",
      f_language: "Language needed",
      f_status: "Status",
      f_open: "Open for participation",
      f_date_from: "From",
      f_date_to: "To",
      clear_filters: "Clear filters",
      all_statuses: "All",
      no_match_title: "No initiatives match",
      no_match_desc: "Adjust or clear the filters to see more initiatives.",
      join_intro: "Join this initiative as a professional.",
      cta_login: "Log in",
      cta_create_profile: "Create professional profile",
      cta_guest_note: "Log in or create your professional profile to request participation.",
      pick_dates: "Select date(s)",
      single_day: "Single day",
      date_range: "Date range",
      clear_dates: "Clear dates",
      category: "Category",
      specialty: "Specialty",
      spots_remaining_one: "{n} spot remaining",
      spots_remaining_other: "{n} spots remaining",
    },
    opportunities: {
      title: "Professional opportunities",
      subtitle: "Discover open professional opportunities posted by organizations.",
      badge: "Professional opportunity",
      empty_title: "No open opportunities yet",
      empty_desc: "When organizations post professional opportunities, they'll appear here.",
      no_match_title: "No opportunities match",
      no_match_desc: "Adjust or clear the filters to see more opportunities.",
      search_placeholder: "Search opportunities…",
      filters: "Filters",
      advanced: "Advanced filters",
      clear_filters: "Clear filters",
      view_details: "View details",
      results: "opportunities",
      result: "opportunity",
      open_status: "Open",
      closed_status: "Closed",
      full_status: "Positions filled",
      deadline_passed: "Deadline passed",
      f_profession: "Required profession",
      f_language: "Required language",
      f_location: "Country or location",
      f_modality: "Modality",
      f_engagement: "Engagement type",
      f_compensation: "Compensation",
      f_verified_required: "Requires verified credentials",
      f_experience: "Required experience",
      f_crisis: "Crisis / disaster response",
      f_group: "Group work",
      f_training: "Training / workshop",
      f_organizational: "Organizational experience",
      f_deadline_before: "Deadline on or before",
      f_open_only: "Open opportunities only",
      section_about: "About the opportunity",
      section_org: "Organization",
      section_requirements: "Professional requirements",
      section_engagement: "Engagement details",
      section_dates: "Dates",
      section_location: "Location & modality",
      section_compensation: "Compensation",
      required_profession: "Required profession",
      required_languages: "Required languages",
      engagement_type: "Engagement type",
      compensation_type: "Compensation",
      min_experience: "Minimum experience",
      professionals_needed: "Professionals needed",
      application_deadline: "Application deadline",
      verified_required: "Requires verified credentials",
      no_specific: "No specific requirements for this opportunity.",
      your_profile: "Compared to your profile",
      met: "You meet this requirement",
      not_met: "You don't meet this requirement",
      compare_note: "Informational comparison with your profile. The organization makes the final decision.",
      profession_mismatch_title: "Your profession doesn't match",
      profession_mismatch_desc: "This opportunity requires a different profession, so you can't apply.",
      apply: "Apply",
      apply_intro: "Apply to this professional opportunity.",
      applied_pending: "Your application is under review.",
      applied_confirmed: "You've been accepted for this opportunity!",
      applied_declined: "Your application wasn't selected this time.",
      years: "years",
      deadline_label: "Deadline",
      closed_note: "This opportunity is no longer accepting applications.",
      req_languages_field: "Required languages",
      deadline_field: "Application deadline",
    },
    inbox: {
      nav: "Inbox",
      title_prof: "Received inquiries",
      title_org: "Sent inquiries",
      empty_prof: "You haven't received any organization inquiries yet.",
      empty_org: "You haven't sent any inquiries to professionals yet.",
      sent_on: "Sent",
      contact: "Contact",
      location: "Location",
      modality: "Modality",
      timeframe: "Date or timeframe",
      language: "Language",
      note: "Note",
      optional_note: "Optional note",
      note_placeholder: "I'm interested. Please contact me to discuss availability and scope.",
      interested: "Interested",
      decline: "Decline",
      close_inquiry: "Close inquiry",
      view_opportunity: "View opportunity",
      responded: "Your response",
      interested_sent: "Response sent",
      closed_toast: "Inquiry closed",
      closed_by_org: "The organization closed this inquiry.",
      do_not_share: "Do not share confidential clinical or patient information.",
      st_new: "New",
      st_viewed: "Viewed",
      st_interested: "Interested",
      st_declined: "Declined",
      st_closed: "Closed",
    },
    join: {
      title: "Join as a professional",
      subtitle: "Create your professional profile. We collect only what's needed to evaluate it.",
      section_personal: "Personal information",
      section_profession: "Profession & category",
      profession: "Profession",
      years_experience: "Years of experience",
      profession_other: "Specify your profession",
      tag_clinical: "Clinical / licensed professional",
      tag_non_clinical: "Non-clinical professional",
      profession_note: "Your profession and category are shown clearly on your profile. We do not present non-clinical professionals as healthcare providers.",
      section_capabilities: "Professional capabilities",
      works_with: "I work with",
      engagement_types: "Ways I work",
      section_fit: "Fit (optional, self-disclosed)",
      fit_note: "These fields are optional and self-disclosed. They help people seeking cultural or language familiarity.",
      gender: "Gender",
      country_of_origin: "Country of origin",
      cultural_background: "Cultural background",
      service_languages: "Service languages",
      countries_served: "Countries I serve",
      section_professional: "Professional information",
      section_format: "Service format and type",
      section_initiatives: "Initiative availability",
      section_connection: "Connection methods",
      photo: "Profile photo",
      upload_photo: "Upload photo",
      change_photo: "Change photo",
      title_field: "Professional title",
      areas_field: "Areas of practice or experience",
      bio_field: "Professional biography",
      bio_placeholder: "Tell us about your experience and approach…",
      format_label: "How do you offer your services?",
      type_label: "Service type?",
      initiatives_label: "I'm available to participate in organized support initiatives",
      add_connection: "Add connection method",
      connection_type: "Type",
      connection_url: "Link (URL)",
      primary_method: "Primary method",
      set_primary: "Set as primary",
      submit_profile: "Submit for review",
      section_populations: "Population & approach",
      populations_label: "Which populations do you work with?",
      approach_label: "Primary therapeutic approach",
      accepting_label: "I'm currently available for new requests",
      section_payment: "Payment & insurance",
      payment_label: "Accepted payment methods",
      insurance_toggle: "I work with insurance or health coverage",
      insurance_field: "Insurance / coverage details",
      insurance_placeholder: "Note which insurance or coverage systems you work with…",
      payment_disclaimer: "This information is informational only. ConQuién Hoy does not collect payments, process insurance or handle billing.",
      section_links: "Professional links",
      links_label: "Professional or social links",
      link_type: "Type",
      add_link: "Add link",
      section_contact_form: "Contact form",
      enable_contact_form: "Enable a simple contact form on my profile",
      contact_email_label: "Email to receive contact messages",
      contact_email_placeholder: "email@example.com",
      contact_form_hint: "Messages are for an introductory contact only. Do not request or share medical information.",
      pending_title: "Profile submitted — Pending review",
      pending_desc: "Thank you. An ConQuién Hoy administrator will review your profile before publishing it. Profiles are not made public automatically.",
      go_workspace: "Go to my workspace",
      select_areas: "Select your areas",
    },
    onboarding: {
      title: "Create your professional profile",
      subtitle: "We save your progress automatically. You can leave and come back any time.",
      contact_title: "Contact information",
      contact_email_label: "Contact email",
      contact_email_hint: "Required. Can differ from your account email.",
      use_contact_form: "Receive messages via a form (your email won't be shown publicly)",
      phone_label: "Phone (optional)",
      phone_hint: "Include the country code. E.g.: +57 300 123 4567",
      phone_public_label: "Show my phone number publicly",
      phone_public_hint: "Off by default. If enabled, your phone will appear on your public profile.",
      other_country_label: "Another country",
      other_country_placeholder: "Search and add a country…",
      other_country_hint: "Pick from the list to add more countries you serve.",
      links_title: "Links (optional)",
      website_label: "Website",
      booking_label: "Booking link",
      booking_hint: "External scheduling link if you already use another service.",
      video_label: "Video meeting link",
      availability_notes_label: "Availability notes (optional)",
      availability_notes_hint: "Any extra information you'd like to share about your availability.",
      go_workspace: "Go to my workspace",
      stage_account: "Account",
      stage_identity: "Professional identity",
      stage_experience: "Experience & focus",
      stage_services: "Services & capabilities",
      stage_profile: "Profile",
      stage_availability: "Availability",
      stage_review: "Review",
      stage_submitted: "Submitted",
      step_of: "Step {n} of {total}",
      save_continue: "Save and continue",
      save_exit: "Save and exit",
      back: "Back",
      draft_saved: "Draft saved",
      save_error: "Couldn't save. Please try again.",
      choose_profession: "What is your profession?",
      choose_profession_hint: "Pick the option that best describes you. It's shown clearly on your profile.",
      account_intro: "Basic contact and location details.",
      identity_intro: "Your profession, title and credentials.",
      credentials: "Professional credentials",
      credentials_hint: "As a clinical professional, we need your license information to verify you.",
      credential_type: "Credential / registration type",
      review_title: "Review your profile before submitting",
      review_intro: "Check that everything is correct. You can edit any section.",
      incomplete_title: "Some required details are missing",
      incomplete_desc: "Complete the highlighted fields to submit your profile for review.",
      submit: "Submit for review",
      resubmit: "Resubmit for review",
      not_provided: "Not provided",
      submitted_title: "Profile submitted! — Pending review",
      submitted_desc: "Thank you. An ConQuién Hoy administrator will review your profile before publishing it. You'll receive an email when its status changes.",
      resubmitted_desc: "Thank you. We've received your changes and your profile is pending review again.",
      missing_full_name: "Full name",
      missing_profession: "Profession",
      missing_profession_other: "Specify your profession",
      missing_country: "Country",
      missing_bio: "Professional biography",
      missing_years_experience: "Years of experience",
      missing_languages: "Languages",
      missing_engagement_types: "Ways you work",
      missing_connection_methods: "At least one connection method",
      missing_license_number: "License number",
      missing_license_org: "Issuing organization",
      missing_license_country: "License country",
      missing_expertise: "Areas of expertise",
      missing_who: "Who you work with",
      missing_services: "How you work",
      missing_populations_served: "Populations",
      missing_service_languages: "Languages you teach",
      missing_contact_email: "Contact email",
      category_label: "Professional category",
      category_hint: "Choose the area that best fits your work.",
      profession_public_note: "Your profession and specialties are shown on your public profile.",
      qual_placeholder: "Certifications, training or relevant experience…",
      qual_note: "Share relevant qualifications — not treated as a clinical license.",
      languages_you_teach: "Languages you teach",
      specialties_label: "Specialties / capabilities",
      specialties_hint: "What can you help someone with?",
      specialty_add_placeholder: "Add a specialty…",
      add_btn: "Add",
      payment_info_note: "This is informational only. ConQuién Hoy does not process payments or billing.",
      no_matches: "No matches",
    },
    booking: {
      book_cta: "Book appointment",
      agenda: "Agenda",
      my_appts: "My appointments",
      upcoming: "Upcoming",
      past: "Past",
      settings: "Booking settings",
      appointments: "Appointments",
      availability: "Availability",
      client: "Client",
      reschedule: "Reschedule",
      reschedule_title: "Reschedule appointment",
      choose_new_time: "Choose a new time",
      no_slots: "No available times that day.",
      rescheduled_ok: "Appointment rescheduled",
      reschedule_err: "Could not reschedule",
      confirm_new_time: "Confirm new time",
      mark_completed: "Completed",
      mark_no_show: "No-show",
      status_updated: "Status updated",
      account: "My account",
      account_settings: "Account settings",
      account_desc: "Manage your timezone and how you'd like to be notified.",
      your_timezone: "Your timezone",
      phone: "Phone (optional)",
      notif_prefs: "Notification preferences",
      notif_email: "Email",
      notif_inapp: "In-app",
      notif_whatsapp: "WhatsApp (coming soon)",
      whatsapp_note: "Enable WhatsApp to receive reminders this way once available.",
      settings_saved: "Settings saved",
      settings_err: "Could not save settings",
      no_appts_psy: "You have no appointments yet",
      reminders_note: "Reminders are sent automatically 24h and 3h before.",
      status_accepting: "Accepting appointments",
      status_limited: "Limited availability",
      status_not_accepting: "Not currently accepting appointments",
      reminder_preview_title: "What you'll receive",
      reminder_email_title: "Email",
      reminder_email_24: "24 hours before your appointment",
      reminder_email_3: "3 hours before your appointment",
      reminder_email_off: "You won't receive email reminders",
      reminder_inapp_title: "In-app",
      reminder_inapp_desc: "Appointment and scheduling updates in My appointments",
      reminder_inapp_off: "No in-app updates",
      no_slots_hint: "You can only pick days with available times.",
      confirm_cancel: "Cancel this appointment?",
      cancelled_ok: "Appointment cancelled",
      cancel_err: "Could not cancel",
      update_err: "Could not update",
      add_appt: "Add appointment",
      manual_tag: "Manual",
      st_confirmed: "Confirmed",
      st_cancelled: "Cancelled",
      st_completed: "Completed",
      st_no_show: "No-show",
      st_rescheduled: "Rescheduled",
      enter_client_name: "Enter the client name",
      choose_date_time: "Choose date and time",
      invalid_duration: "Invalid duration",
      appt_rescheduled: "Appointment rescheduled",
      appt_added: "Appointment added to your agenda",
      save_appt_err: "Could not save the appointment",
      reschedule_appt: "Reschedule appointment",
      choose_new_date_time: "Choose the new date and time.",
      manual_desc: "Log an appointment for a client you see off-platform. No account needed.",
      client_name: "Client name",
      client_name_ph: "e.g. Sample Client",
      date: "Date",
      start_time: "Start time",
      duration_min: "Duration (minutes)",
      type_title_opt: "Type / title (optional)",
      type_title_ph: "e.g. Follow-up session",
      private_note_opt: "Private note (optional)",
      private_note_ph: "Only you can see this",
      client_email_opt: "Client email (optional)",
      email_will_send: "Confirmation and reminders will be sent to the client.",
      email_internal: "Without an email, the appointment is internal only (no client notifications).",
      email_language: "Email language",
      email_lang_note: "The client will receive emails in this language.",
      save_changes: "Save changes",
      booked_ok: "Appointment booked!",
      slot_unavailable: "That slot is no longer available",
      appt_type: "Appointment type",
      modality: "Modality",
      choose_date: "Choose a date",
      your_local_time: "Your local time",
      no_times_day: "No available times that day.",
      continue: "Continue",
      professional_time: "Professional's time",
      confirm_booking: "Confirm booking",
      pick_time_again: "Please pick a time again.",
      back: "Back",
      appt_confirmed: "Your appointment is confirmed.",
      confirmation_email_sent: "We've sent you a confirmation email.",
      create_account: "Create account",
      sign_in: "Sign in",
      account_needed: "You need an account to book. We don't ask for clinical information.",
      full_name: "Full name",
      email: "Email",
      password: "Password",
      phone_opt: "Phone (optional)",
      tz_autodetect: "Auto-detected — please confirm.",
      create_continue: "Create account & continue",
      current: "Current",
      no_appts_client: "No appointments here",
      find_professional: "Find a professional",
      add_to_calendar: "Add to calendar",
      book_again: "Book again",
      enable_booking: "Enable booking on my profile",
      avail_tz_note: "Your availability is defined in your local time.",
      weekly_avail: "Weekly availability",
      unavailable: "Unavailable",
      appt_types: "Appointment types",
      add: "Add",
      buffer_before: "Buffer before (min)",
      buffer_after: "Buffer after (min)",
      min_notice: "Minimum notice (hours)",
      booking_horizon: "Booking horizon (days)",
      blocked_dates: "Blocked dates",
      all_day: "All day",
      internal_note_priv: "Internal note (private)",
      type_label_ph: "Label (e.g. Consultation)",
      default_short: "Default",
      location_inperson: "Location (in-person)",
      online_info: "Online session info",
      cancel_policy_opt: "Cancellation policy (optional)",
      advance_reminder: "Advance reminder",
      sameday_reminder: "Same-day reminder",
      cal_event_title: "Appointment with",
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    },
    contact: {
      title: "Send a message",
      desc: "Introduce yourself briefly. This form is for a first contact only.",
      notice: "Do not include medical information, diagnoses, clinical histories, emergency information or sensitive health data.",
      name: "Your name",
      email: "Your email",
      message: "Short message",
      send: "Send message",
      sending: "Sending…",
      sent: "Your message has been sent.",
      error: "The message could not be sent. Please try again.",
    },
    auth: {
      login_title: "Log in",
      register_title: "Create account",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      register_here: "Register here",
      login_here: "Log in",
      role_label: "I want to register as",
      role_psychologist: "Psychologist",
      role_organizer: "Organizer",
      accept_terms_pre: "I have read and accept the",
      terms_link: "Terms of Use",
      and: "and the",
      privacy_link: "Privacy Policy",
      login_btn: "Enter",
      register_btn: "Create account",
      logging_in: "Signing in…",
      creating: "Creating account…",
      organizer_pending: "Your organizer account is pending administrator approval.",
      forgot: "Forgot password?",
      choose_participation: "Please choose how you want to take part.",
      register_professional_title: "Create professional account",
      register_org_title: "Create organization account",
      register_client_title: "Create your account",
      participate_q: "How do you want to take part in ConQuién Hoy?",
      participate_client: "I'm looking for someone to talk to",
      participate_professional: "I want to offer my services",
      participate_org: "I represent an organization",
    },
    forgot: {
      title: "Recover password",
      subtitle: "Enter your email and we'll send instructions to reset your password.",
      submit: "Send instructions",
      confirmation: "If an account exists for that email, we've sent password reset instructions. Please check your inbox.",
    },
    reset: {
      title: "Reset password",
      new_password: "New password",
      confirm_password: "Confirm new password",
      hint: "At least 8 characters, with letters and numbers.",
      submit: "Change password",
      success: "Password reset. You can now sign in.",
      mismatch: "Passwords do not match.",
      invalid: "This reset link is invalid or has expired.",
    },
    workspace: {
      title: "My workspace",
      profile: "My profile",
      links: "My links",
      initiatives: "My initiatives",
      availability: "Availability",
      no_profile_title: "You haven't created your profile yet",
      no_profile_desc: "Create your professional profile to appear in the directory after review.",
      create_profile: "Create my profile",
      status_pending: "Your profile is pending review by an administrator.",
      status_verified: "Your profile is verified and visible in the directory.",
      status_rejected: "Your profile was not approved. You can edit it and resubmit.",
      status_suspended: "Your profile has been suspended. Please contact administration.",
      no_initiatives: "You aren't participating in any initiative yet.",
      view_initiative: "View initiative",
      participations_all: "All",
      participations_initiatives: "Initiatives",
      participations_opportunities: "Opportunities",
      profile_saved: "Profile saved successfully.",
      links_saved: "Links updated.",
      changes_banner_title: "A few changes are needed before we can continue.",
      update_profile: "Update profile",
      resubmit: "Resubmit for review",
      status_changes: "An administrator has requested changes to your profile. Review them, update your information and resubmit.",
      settings: "Settings",
      status_draft: "Your profile is a draft. Continue where you left off to submit it for review.",
      status_changes_short: "Changes requested",
      draft_banner: "Finish your onboarding to submit your profile for review.",
      continue_onboarding: "Continue onboarding",
      requested_changes_label: "Requested changes:",
    },
    del: {
      section_title: "Danger zone",
      pro_button: "Delete professional profile",
      pro_desc: "This deletes your professional profile, not your ConQuién Hoy account. Your login is kept and you can create a new profile later.",
      confirm_title: "Delete your professional profile permanently?",
      confirm_body: "Your professional profile will no longer be available on ConQuién Hoy and the associated data that can be safely removed will be deleted. This action cannot be undone.",
      cancel: "Cancel",
      confirm_action: "Delete permanently",
      success: "Professional profile deleted.",
      blocked_title: "Can't delete right now",
      blocked_body: "This profile has linked activity (appointments, participations or messages) that must be preserved. To protect that history, the profile can't be permanently deleted at this time.",
      error: "The profile could not be deleted. Please try again.",
      admin_button: "Delete profile",
      admin_confirm_title: "Delete this professional profile permanently?",
      admin_confirm_body: "The profile and the associated data that can be safely removed will be deleted. The user's login account will not be deleted. This action cannot be undone.",
      admin_success: "Professional profile deleted.",
    },
    organizer: {
      title: "Organizer panel",
      pending_account: "Your organizer account is pending approval. You'll be able to create initiatives once approved.",
      new_initiative: "New initiative",
      my_initiatives: "My initiatives",
      no_initiatives: "You haven't created any initiatives yet.",
      create_title: "Create initiative",
      edit_title: "Edit initiative",
      name: "Initiative name",
      publish: "Publish",
      unpublish: "Unpublish",
      close: "Close initiative",
      participants: "Participants",
      review_participants: "Review participants",
      contact: "Contact",
      no_participants: "No participation requests yet.",
      saved: "Initiative saved.",
      dashboard_subtitle: "Manage your initiatives: share, recruit, review requests and coordinate your team.",
      open_workspace: "Open workspace",
      back_dashboard: "Back to dashboard",
      overview: "Overview",
      team: "Team",
      applicants_tab: "Applicants",
      availability_tab: "Availability",
      contacts_tab: "Contacts",
      notes_tab: "Notes",
      share_tab: "Share",
      quick_edit: "Edit initiative",
      team_roster: "Initiative team",
      filter_status: "Filter by status",
      view_profile: "View profile",
      no_team: "No professionals on the team yet.",
      new_requests: "New requests",
      confirmed_participants: "Confirmed participants",
      availability_desc: "A quick view of confirmed participants' availability.",
      no_availability: "No confirmed participants yet.",
      contacts_desc: "Contact information for confirmed participants. Visible only to you.",
      no_contacts: "No confirmed participants yet.",
      notes_title: "Coordination notes",
      notes_desc: "A space for logistical information. Do not include clinical or patient information.",
      add_note: "Add note",
      note_placeholder: "Write a logistical note…",
      no_notes: "No notes yet.",
      share_title: "Public initiative link",
      share_desc: "Share this link through the channels you already use. It leads to the public page where professionals can request to participate.",
      copy_link: "Copy link",
      link_copied: "Link copied to clipboard",
      share_draft_note: "This initiative is a draft. Publish it so the link is publicly accessible.",
      reach_tab: "Reach",
      reach_title: "Initiative reach",
      reach_desc: "Activity generated within ConQuién Hoy for this initiative. Aggregate, anonymous data.",
      reach_views: "Page views",
      reach_shares: "Share actions",
      reach_copy: "Copy link",
      reach_whatsapp: "WhatsApp",
      reach_email: "Email",
      reach_requests: "Participation requests",
      reach_note: "These metrics only reflect activity within ConQuién Hoy and never identify individual visitors.",
      visibility: "Visibility",
      org_profile_title: "Organization profile",
      org_profile_desc: "Required to invite professionals to opportunities.",
      org_profile_saved: "Organization profile saved",
      org_profile_error: "Could not save",
      org_name_label: "Organization name",
      org_type_label: "Type",
      org_contact_label: "Contact person",
      org_website_label: "Website",
    },
    inquiry: {
      sent: "Inquiry sent",
      send_error: "Could not send",
      title: "Invite to an opportunity",
      desc: "You are contacting {name} on behalf of your organization.",
      type_label: "Opportunity type",
      location: "Location",
      modality: "Modality",
      hybrid: "Hybrid",
      timeframe: "Date or timeframe",
      language_required: "Language required",
      warning: "Do not include confidential clinical or patient information.",
      submit: "Send inquiry",
    },
    admin: {
      title: "Administration",
      psychologists: "Psychologists",
      professionals: "Professionals",
      organizers: "Organizers",
      initiatives: "Initiatives",
      areas: "Areas of support",
      pending: "Pending",
      changes: "Changes requested",
      verified: "Verified",
      all: "All",
      stats_pending: "Pending professionals",
      stats_verified: "Verified professionals",
      stats_org_pending: "Pending organizers",
      stats_initiatives: "Initiatives",
      suspend: "Suspend",
      restrict: "Restrict",
      area_es: "Name (ES)",
      area_en: "Name (EN)",
      add_area: "Add area",
      no_psychologists: "No professionals in this category.",
      all_professions: "All professions",
      no_organizers: "No organizers registered yet.",
      security: "Security",
      change_password: "Change password",
      current_password: "Current password",
      new_password: "New password",
      confirm_password: "Confirm new password",
      pw_hint: "At least 8 characters, with letters and numbers.",
      pw_updated: "Password updated successfully.",
      pw_mismatch: "Passwords do not match.",
      bookings: "Bookings",
      bk_search: "Search by client or professional",
      bk_all_psych: "All professionals",
      bk_all_status: "All statuses",
      bk_all_modality: "All modalities",
      bk_from: "From",
      bk_to: "To",
      bk_client: "Client",
      bk_psych: "Professional",
      bk_when: "Date & time",
      bk_status: "Status",
      bk_modality: "Modality",
      bk_reminders: "Reminders",
      bk_none: "No bookings match.",
      bk_rescheduled: "reschedule(s)",
      bk_clear: "Clear filters",
      bk_note: "Read-only operational view. No clinical content is stored or shown.",
      stat_awaiting_review: "Professionals awaiting review",
      open_review_queue: "Open review queue →",
      all_categories: "All",
      credentials: "Credentials",
      cred_type: "Type",
      cred_license: "License",
      qualifications: "Qualifications & experience",
      years_short: "yrs",
      request_changes: "Request changes",
      note_prompt: "Note to the professional:",
      initiative_deleted: "Initiative deleted",
      delete_initiative: "Delete initiative",
      delete_init_title: "Delete this initiative permanently?",
      delete_init_body: "The initiative record and its participation entries will be permanently removed. The organizer's account is not affected. This cannot be undone.",
      bk_load_error: "Could not load bookings. Please try again.",
      bk_st_confirmed: "Confirmed",
      bk_st_cancelled: "Cancelled",
      bk_st_completed: "Completed",
      bk_st_no_show: "No-show",
      bk_st_rescheduled: "Rescheduled",
    },
    footer: {
      legal: "Legal",
      tagline: "A platform to bring people together.",
      owned: "A project by Alias Distribution LLC.",
      rights: "© 2026 Alias Distribution LLC. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      disclaimer: "Professional & Medical Disclaimer",
      copyright: "Copyright",
      disclaimer_short: "ConQuién Hoy is a connection platform and does not provide therapy, medical advice, diagnosis, treatment or emergency services. Professionals listed on ConQuién Hoy provide their services independently.",
    },
    emergency: {
      text: "ConQuién Hoy is not an emergency service. If you are experiencing an emergency, contact the emergency services available in your location.",
    },
    legal: {
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      disclaimer: "Professional & Medical Disclaimer",
      copyright: "Copyright",
    },
    notfound: { title: "Page not found", desc: "The page you're looking for doesn't exist.", home: "Back to home" },
  },
  am: {
    // Batch 1 calibration — homepage chrome only. Initial, NOT final human-approved copy.
    // All other keys intentionally fall back to Spanish.
    brand: { tagline: "ለዛሬ የሚያስፈልግዎት ትክክለኛው ሰው።" },
    langgate: {
      title: "ቋንቋዎን ይምረጡ",
      subtitle: "ኮንኪየን ሆይ በEnglish፣ Español እና አማርኛ ይገኛል።",
      default: "ነባሪ",
    },
    nav: {
      home: "መነሻ",
      find: "ባለሙያ ያግኙ",
      psychologists: "ባለሙያ ይፈልጉ",
      initiatives: "ተነሳሽነቶች",
      opportunities: "ዕድሎች",
      join: "አገልግሎቴን ላቅርብ",
      login: "ይግቡ",
      logout: "ይውጡ",
      account: "መለያዬ",
      admin: "አስተዳደር",
      organizer: "አዘጋጅ",
      workspace: "የሥራ ቦታዬ",
    },
    home: {
      hero_sub: "ኮንኪየን ሆይ ለዛሬ የሚያስፈልግዎትን ትክክለኛ ሰው እንዲያገኙ ይረዳዎታል፦ ስሜታዊ ወይም ሥነ-ልቦናዊ ድጋፍ፣ ኮቺንግ፣ ግንኙነት፣ የሙያ መመሪያ፣ የንግድ አማካሪነት እና ሌሎችም። የተረጋገጡ ወይም የተገመገሙ ባለሙያዎችን በሚጠቀሙባቸው መሣሪያዎች በኩል ያገናኙ።",
      cta_find: "ባለሙያ ያግኙ",
      cta_join: "አገልግሎቴን ማቅረብ እፈልጋለሁ",
      how_title: "እንዴት እንደሚሠራ",
      how_sub: "ርቀቱን ለማቅረብ ሦስት ቀላል ደረጃዎች።",
      step1_title: "ይፈልጉ",
      step1_desc: "ለእርስዎ በጣም አስፈላጊ በሆኑ ምርጫዎች መሠረት ባለሙያዎችን ያግኙ።",
      step2_title: "ይገናኙ",
      step2_desc: "መረጃቸውን፣ ተገኝነታቸውን እና የሚገኙ የመገናኛ መንገዶችን ይመልከቱ።",
      step3_title: "ይነጋገሩ",
      step3_desc: "ባለሙያው በሚያቀርበው የመገናኛ ወይም የቀጠሮ መንገድ ይቀጥሉ።",
      initiatives_title: "የድጋፍ ተነሳሽነቶች",
      initiatives_desc: "ኮንኪየን ሆይ ባለሙያዎችን ከተደራጁ የድጋፍ ተነሳሽነቶች ጋር ያገናኛል።",
      initiatives_cta: "ተነሳሽነቶችን ይመልከቱ",
      trust_title: "ሰዎችን የሚያቀራርብ መድረክ",
      trust_desc: "ነጻ ባለሙያዎች አገልግሎቶቹን ያቀርባሉ። ኮንኪየን ሆይ ግንኙነቱን ያመቻቻል።",
    },
    footer: {
      legal: "ሕጋዊ",
      tagline: "ሰዎችን ለማቀራረብ የተዘጋጀ መድረክ።",
      owned: "የአሊያስ ዲስትሪቡሽን ኤልኤልሲ ፕሮጀክት።",
      rights: "© 2026 Alias Distribution LLC. መብቱ በሙሉ የተጠበቀ ነው።",
      privacy: "የግላዊነት መመሪያ",
      terms: "የአጠቃቀም ውሎች",
      disclaimer: "የሙያ እና የሕክምና ማስታወቂያ",
      copyright: "የቅጂ መብት",
      disclaimer_short: "ኮንኪየን ሆይ የማገናኘት መድረክ እንጂ ቴራፒ፣ የሕክምና ምክር፣ ምርመራ፣ ሕክምና ወይም የአደጋ ጊዜ አገልግሎት አይሰጥም። በኮንኪየን ሆይ የተዘረዘሩ ባለሙያዎች አገልግሎታቸውን በራሳቸው ነጻነት ያቀርባሉ።",
    },
    emergency: {
      text: "ኮንኪየን ሆይ የአደጋ ጊዜ አገልግሎት አይደለም። የአደጋ ሁኔታ እያጋጠመዎት ከሆነ፣ በአካባቢዎ የሚገኙትን የአደጋ ጊዜ አገልግሎቶች ያግኙ።",
    },
    common: {
      loading: "በመጫን ላይ…",
      search: "ፈልግ",
      clear: "አጽዳ",
      filters: "ማጣሪያዎች",
      all: "ሁሉም",
      save: "አስቀምጥ",
      cancel: "ይቅር",
      submit: "አስገባ",
      back: "ተመለስ",
      edit: "አርትዕ",
      delete: "ሰርዝ",
      close: "ዝጋ",
      confirm: "አረጋግጥ",
      decline: "አትቀበል",
      approve: "አጽድቅ",
      reject: "አትቀበል",
      view: "እይ",
      online: "በመስመር ላይ",
      in_person: "በአካል",
      both: "ሁለቱም",
      any: "ማንኛውም",
      hybrid: "ድብልቅ",
      paid: "በክፍያ",
      volunteer: "በፈቃደኝነት / ነጻ",
      language: "ቋንቋ",
      country: "አገር",
      city: "ከተማ",
      optional: "አማራጭ",
      required: "ግዴታ",
      status: "ሁኔታ",
      email: "ኢሜይል",
      password: "የይለፍ ቃል",
      name: "ሙሉ ስም",
      phone: "ስልክ",
      saving: "በማስቀመጥ ላይ…",
      none: "ምንም",
      not_provided: "አልተገለጸም",
      yes: "አዎ",
      no: "አይ",
      share: "አጋራ",
      copy_link: "አገናኝ ቅዳ",
      link_copied: "አገናኙ ተቀድቷል",
    },
    status: {
      pending: "ለግምገማ በመጠባበቅ ላይ",
      verified: "የተረጋገጠ",
      rejected: "ተቀባይነት አላገኘም",
      suspended: "ታግዷል",
      confirmed: "ተረጋግጧል",
      declined: "ተቀባይነት አላገኘም",
      approved: "ጸድቋል",
      draft: "ረቂቅ",
      changes: "ለውጦች ተጠይቀዋል",
      closed: "ተዘግቷል",
    },
    inquiry: {
      sent: "ግብዣ ተልኳል",
      send_error: "መላክ አልተቻለም",
      title: "ወደ ዕድል ጋብዝ",
      desc: "{name}ን በድርጅትህ ስም እያገኘህ ነው።",
      type_label: "የዕድል ዓይነት",
      location: "አካባቢ",
      modality: "ዘዴ",
      hybrid: "ድብልቅ",
      timeframe: "ቀን ወይም ጊዜ",
      language_required: "የሚያስፈልግ ቋንቋ",
      warning: "ሚስጥራዊ ክሊኒካዊ መረጃ ወይም የታካሚ መረጃ አታካትት።",
      submit: "ግብዣ ላክ",
    },
    admin: {
      title: "አስተዳደር",
      psychologists: "የሥነ-ልቦና ባለሙያዎች",
      professionals: "ባለሙያዎች",
      organizers: "አዘጋጆች",
      initiatives: "ተነሳሽነቶች",
      areas: "የድጋፍ መስኮች",
      pending: "በመጠባበቅ ላይ",
      changes: "ለውጦች ተጠይቀዋል",
      verified: "የተረጋገጡ",
      all: "ሁሉም",
      stats_pending: "በመጠባበቅ ላይ ያሉ ባለሙያዎች",
      stats_verified: "የተረጋገጡ ባለሙያዎች",
      stats_org_pending: "በመጠባበቅ ላይ ያሉ አዘጋጆች",
      stats_initiatives: "ተነሳሽነቶች",
      suspend: "አግድ",
      restrict: "ገድብ",
      area_es: "ስም (ES)",
      area_en: "ስም (EN)",
      add_area: "መስክ ጨምር",
      no_psychologists: "በዚህ ምድብ ውስጥ ባለሙያዎች የሉም።",
      all_professions: "ሁሉም ሙያዎች",
      no_organizers: "እስካሁን የተመዘገቡ አዘጋጆች የሉም።",
      security: "ደህንነት",
      change_password: "የይለፍ ቃል ቀይር",
      current_password: "የአሁኑ የይለፍ ቃል",
      new_password: "አዲስ የይለፍ ቃል",
      confirm_password: "አዲሱን የይለፍ ቃል አረጋግጥ",
      pw_hint: "ቢያንስ 8 ቁምፊዎች፣ ፊደላትና ቁጥሮችን የያዘ።",
      pw_updated: "የይለፍ ቃል በተሳካ ሁኔታ ተዘምኗል።",
      pw_mismatch: "የይለፍ ቃላቱ አይዛመዱም።",
      bookings: "ቀጠሮዎች",
      bk_search: "በደንበኛ ወይም በባለሙያ ፈልግ",
      bk_all_psych: "ሁሉም ባለሙያዎች",
      bk_all_status: "ሁሉም ሁኔታዎች",
      bk_all_modality: "ሁሉም ዘዴዎች",
      bk_from: "ከ",
      bk_to: "እስከ",
      bk_client: "ደንበኛ",
      bk_psych: "ባለሙያ",
      bk_when: "ቀንና ሰዓት",
      bk_status: "ሁኔታ",
      bk_modality: "ዘዴ",
      bk_reminders: "ማስታወሻዎች",
      bk_none: "የሚዛመድ ቀጠሮ የለም።",
      bk_rescheduled: "ዳግም መርሐግብር",
      bk_clear: "ማጣሪያዎችን አጽዳ",
      bk_note: "የንባብ ብቻ የሥራ እይታ። ምንም ክሊኒካዊ ይዘት አይከማችም ወይም አይታይም።",
      stat_awaiting_review: "ለግምገማ የሚጠብቁ ባለሙያዎች",
      open_review_queue: "የግምገማ ወረፋ ክፈት →",
      all_categories: "ሁሉም",
      credentials: "ምስክርነቶች",
      cred_type: "ዓይነት",
      cred_license: "ፈቃድ",
      qualifications: "ብቃቶችና ልምድ",
      years_short: "ዓመታት",
      request_changes: "ለውጦች ጠይቅ",
      note_prompt: "ለባለሙያው የሚሆን ማስታወሻ:",
      initiative_deleted: "ተነሳሽነት ተሰርዟል",
      delete_initiative: "ተነሳሽነት ሰርዝ",
      delete_init_title: "ይህን ተነሳሽነት በቋሚነት ይሰረዝ?",
      delete_init_body: "የተነሳሽነቱ መዝገብና የተሳትፎ ግቤቶቹ በቋሚነት ይወገዳሉ። የአዘጋጁ መለያ አይጎዳም። ይህ መቀልበስ አይቻልም።",
      bk_load_error: "ቀጠሮዎችን መጫን አልተቻለም። እባክዎ እንደገና ይሞክሩ።",
      bk_st_confirmed: "ተረጋግጧል",
      bk_st_cancelled: "ተሰርዟል",
      bk_st_completed: "ተጠናቋል",
      bk_st_no_show: "አልቀረበም",
      bk_st_rescheduled: "ዳግም ተይዟል",
    },
    find: {
      title: "ባለሙያ ያግኙ",
      subtitle: "የተረጋገጡ ባለሙያዎችን — ሥነ-ልቦና፣ ኮቺንግ እና ሌሎችም — መለያ ሳይፈጥሩ ይፈልጉ።",
      results: "ባለሙያዎች ተገኝተዋል",
      result: "ባለሙያ ተገኝቷል",
      f_language: "ቋንቋ",
      f_profession: "ሙያ",
      f_category: "ምድብ",
      f_works_with: "ከማን ጋር ይሠራል",
      f_engagement: "የሥራ ዓይነት",
      f_experience: "ዝቅተኛ ልምድ",
      f_gender: "ጾታ",
      f_origin: "የትውልድ አገር",
      f_culture: "የባህል ዳራ",
      years: "ዓመታት",
      intent_q: "ዛሬ ምን ይፈልጋሉ?",
      profession_q: "ምን ዓይነት ባለሙያ ይፈልጋሉ?",
      guided_label: "በመመሪያ መፈለግ",
      direct_label: "በቀጥታ ፈልግ",
      direct_hint: "ማንን እንደሚፈልጉ ያውቃሉ? ባለሙያዎችን በቀጥታ ይፈልጉ እና ያጣሩ።",
      f_country: "አገር",
      f_city: "ከተማ",
      f_area: "የድጋፍ መስክ",
      f_online: "በመስመር ላይ",
      f_in_person: "በአካል",
      f_paid: "በክፍያ",
      f_volunteer: "በፈቃደኝነት / ነጻ",
      city_placeholder: "ከተማ ይጻፉ",
      f_population: "የሚያገለግለው ሕዝብ",
      f_approach: "የሕክምና አቀራረብ",
      f_accepting: "አዲስ ደንበኞችን ይቀበላል",
      f_insurance: "ከኢንሹራንስ ጋር ይሠራል",
      f_verified_only: "የተረጋገጡ ማስረጃዎች ብቻ",
      empty_title: "እስካሁን የሚዛመድ ባለሙያ የለም",
      empty_desc: "በእነዚህ መስፈርቶች ባለሙያ አላገኘንም። ፍለጋዎን በማስፋት ይሞክሩ።",
      advanced: "የላቁ ማጣሪያዎች",
    },
    directory: {
      title: "የባለሙያዎች ማውጫ",
      subtitle: "በኮንኪየን ሆይ የሚገኙትን የተረጋገጡ ባለሙያዎች ያስሱ።",
      empty_title: "እስካሁን የታተመ ባለሙያ የለም",
      empty_desc: "ማውጫው አሁንም እያደገ ነው። በቅርቡ ይመለሱ ወይም ባለሙያዎችን እንዲቀላቀሉ ይጋብዙ።",
    },
    profile: {
      about: "ስለ",
      areas: "የድጋፍ መስኮች",
      credentials: "የሙያ ማስረጃዎች",
      qualification: "የሙያ ብቃት",
      profession: "ሙያ",
      clinical: "ክሊኒካል / ፈቃድ ያለው",
      non_clinical: "ክሊኒካል ያልሆነ",
      not_verified: "በመድረኩ ያልተረጋገጡ ማስረጃዎች",
      capabilities: "ችሎታዎች",
      works_with: "የምሠራው ከ",
      ways_i_work: "የሥራ መንገዶች",
      experience: "የልምድ ዓመታት",
      license: "የምዝገባ / ፈቃድ ቁጥር",
      license_org: "የሚመዘግበው / ፈቃድ የሚሰጠው ድርጅት",
      license_country: "የሙያ ምዝገባ አገር",
      service_format: "የአገልግሎት ዓይነት",
      service_type: "የአገልግሎት ዓይነት",
      availability: "ተገኝነት",
      initiatives: "ተነሳሽነቶች",
      available_initiatives: "ለተደራጁ የድጋፍ ተነሳሽነቶች ዝግጁ",
      not_available_initiatives: "በአሁኑ ጊዜ ለተነሳሽነቶች ዝግጁ አይደለም",
      connect: "ይገናኙ",
      email_cta: "ኢሜይል",
      connect_primary: "አሁን ይገናኙ",
      other_methods: "ሌሎች የመገናኛ መንገዶች",
      connect_note: "ይህ አገናኝ በባለሙያው የሚተዳደር ውጫዊ መሣሪያ ይከፍታል።",
      no_bio: "ይህ ባለሙያ እስካሁን የሕይወት ታሪክ አላከለም።",
      verified_note: "በኮንኪየን ሆይ የተረጋገጠ",
      verified_desc: "ይህ ባለሙያ ያቀረባቸውን መረጃዎች እና ማስረጃዎች ገምግመናል። ፈቃድ አንሰጥም ወይም ውጤቶችን አናረጋግጥም።",
      book_appointment: "ቀጠሮ ይያዙ",
      not_verified_note: "በባለሙያው የቀረበ መረጃ",
      populations: "የሚያገለግለው ሕዝብ",
      approach: "የሕክምና አቀራረብ",
      accepting_new: "አዲስ ደንበኞችን እየተቀበለ ነው",
      not_accepting: "በአሁኑ ጊዜ አዲስ ደንበኞችን አይቀበልም",
      payment: "የክፍያ መንገዶች",
      insurance: "ኢንሹራንስ / የጤና ሽፋን",
      works_insurance: "ከኢንሹራንስ ወይም ከጤና ሽፋን ጋር ይሠራል",
      no_insurance: "ከኢንሹራንስ ጋር አይሠራም",
      payment_note: "በባለሙያው የቀረበ መረጃ። ኮንኪየን ሆይ ክፍያ አያስተናግድም ወይም ኢንሹራንስ አያስተዳድርም፤ ማንኛውም የገንዘብ ስምምነት በቀጥታ ከባለሙያው ጋር ነው።",
      links: "የሙያ አገናኞች",
      leaving_site: "ከኮንኪየን ሆይ ወደ ውጫዊ ጣቢያ እየወጡ ነው።",
      share_title: "መገለጫ አጋራ",
      share_desc: "ይህን መገለጫ ለማጋራት ይፋዊ አገናኙን ይቅዱ።",
      professional_fallback: "ባለሙያ",
      specialties: "ልዩ ሙያዎች",
      languages_taught: "የሚያስተምሯቸው ቋንቋዎች",
      qualifications: "ብቃቶች",
      not_available_title: "መገለጫ አይገኝም",
      not_available_desc: "ይህ የባለሙያ መገለጫ የለም ወይም ገና አልታተመም።",
      back_to_directory: "ወደ ማውጫ ይመለሱ",
      payment_note_generic: "በባለሙያው የቀረበ መረጃ። ኮንኪየን ሆይ ክፍያ አያስተናግድም፤ ማንኛውም የገንዘብ ስምምነት በቀጥታ ከባለሙያው ጋር ነው።",
      invite_opportunity: "ወደ ዕድል ይጋብዙ",
    },
    auth: {
      login_title: "ይግቡ",
      register_title: "መለያ ይፍጠሩ",
      no_account: "መለያ የለዎትም?",
      have_account: "መለያ አለዎት?",
      register_here: "እዚህ ይመዝገቡ",
      login_here: "ይግቡ",
      role_label: "መመዝገብ የምፈልገው እንደ",
      role_psychologist: "የሥነ-ልቦና ባለሙያ",
      role_organizer: "አዘጋጅ",
      accept_terms_pre: "አንብቤ ተቀብያለሁ",
      terms_link: "የአጠቃቀም ውሎች",
      and: "እና",
      privacy_link: "የግላዊነት መመሪያ",
      login_btn: "ግባ",
      register_btn: "መለያ ይፍጠሩ",
      logging_in: "በመግባት ላይ…",
      creating: "መለያ በመፍጠር ላይ…",
      organizer_pending: "የአዘጋጅ መለያዎ በአስተዳዳሪ ማጽደቅን በመጠባበቅ ላይ ነው።",
      forgot: "የይለፍ ቃልዎን ረሱ?",
      choose_participation: "እባክዎ እንዴት መሳተፍ እንደሚፈልጉ ይምረጡ።",
      register_professional_title: "የባለሙያ መለያ ይፍጠሩ",
      register_org_title: "የድርጅት መለያ ይፍጠሩ",
      register_client_title: "መለያዎን ይፍጠሩ",
      participate_q: "በኮንኪየን ሆይ እንዴት መሳተፍ ይፈልጋሉ?",
      participate_client: "የማነጋግረው ሰው እየፈለግኩ ነው",
      participate_professional: "አገልግሎቴን ማቅረብ እፈልጋለሁ",
      participate_org: "አንድን ድርጅት እወክላለሁ",
    },
    join: {
      title: "እንደ ባለሙያ ይቀላቀሉ",
      subtitle: "የባለሙያ መገለጫዎን ይፍጠሩ። ለመገምገም የሚያስፈልገንን ብቻ እንሰበስባለን።",
      section_personal: "የግል መረጃ",
      section_profession: "ሙያ እና ምድብ",
      profession: "ሙያ",
      years_experience: "የልምድ ዓመታት",
      profession_other: "ሙያዎን ይግለጹ",
      tag_clinical: "ክሊኒካል / ፈቃድ ያለው ባለሙያ",
      tag_non_clinical: "ክሊኒካል ያልሆነ ባለሙያ",
      profession_note: "ሙያዎ እና ምድብዎ በመገለጫዎ ላይ በግልጽ ይታያሉ። ክሊኒካል ያልሆኑ ባለሙያዎችን እንደ የጤና ባለሙያ አናቀርብም።",
      section_capabilities: "የሙያ ችሎታዎች",
      works_with: "የምሠራው ከ",
      engagement_types: "የሥራ ዓይነቶች",
      section_fit: "ተዛማጅነት (አማራጭ፣ በራስ የተገለጸ)",
      fit_note: "እነዚህ መስኮች አማራጭ እና በራስ የተገለጹ ናቸው። የባህል ወይም የቋንቋ ተዛማጅነት ለሚፈልጉ ይረዳሉ።",
      gender: "ጾታ",
      country_of_origin: "የትውልድ አገር",
      cultural_background: "የባህል ዳራ",
      service_languages: "የአገልግሎት ቋንቋዎች",
      countries_served: "የማገለግላቸው አገሮች",
      section_professional: "የሙያ መረጃ",
      section_format: "የአገልግሎት ዓይነት እና ሁኔታ",
      section_initiatives: "ለተነሳሽነቶች ተገኝነት",
      section_connection: "የመገናኛ መንገዶች",
      photo: "የመገለጫ ፎቶ",
      upload_photo: "ፎቶ ይስቀሉ",
      change_photo: "ፎቶ ይቀይሩ",
      title_field: "የሙያ ማዕረግ",
      areas_field: "የሥራ ወይም የልምድ መስኮች",
      bio_field: "የሙያ የሕይወት ታሪክ",
      bio_placeholder: "ስለ ልምድዎ እና አቀራረብዎ ይንገሩን…",
      format_label: "አገልግሎትዎን እንዴት ያቀርባሉ?",
      type_label: "የአገልግሎት ዓይነት?",
      initiatives_label: "በተደራጁ የድጋፍ ተነሳሽነቶች ለመሳተፍ ዝግጁ ነኝ",
      add_connection: "የመገናኛ መንገድ ያክሉ",
      connection_type: "ዓይነት",
      connection_url: "አገናኝ (URL)",
      primary_method: "ዋና መንገድ",
      set_primary: "እንደ ዋና ምልክት ያድርጉ",
      submit_profile: "ለግምገማ ይላኩ",
      section_populations: "ሕዝብ እና አቀራረብ",
      populations_label: "ከየትኞቹ ሕዝቦች ጋር ይሠራሉ?",
      approach_label: "ዋና የሕክምና አቀራረብ",
      accepting_label: "በአሁኑ ጊዜ ለአዲስ ጥያቄዎች ዝግጁ ነኝ",
      section_payment: "ክፍያ እና ኢንሹራንስ",
      payment_label: "ተቀባይነት ያላቸው የክፍያ መንገዶች",
      insurance_toggle: "ከኢንሹራንስ ወይም ከጤና ሽፋን ጋር እሠራለሁ",
      insurance_field: "የኢንሹራንስ / ሽፋን ዝርዝሮች",
      insurance_placeholder: "ከየትኞቹ ኢንሹራንሶች ወይም የሽፋን ሥርዓቶች ጋር እንደሚሠሩ ይግለጹ…",
      payment_disclaimer: "ይህ መረጃ ለማሳወቅ ብቻ ነው። ኮንኪየን ሆይ ክፍያ አይቀበልም፣ ኢንሹራንስ አያስተናግድም ወይም ሒሳብ አያስተዳድርም።",
      section_links: "የሙያ አገናኞች",
      links_label: "የሙያ አገናኞች ወይም ማኅበራዊ ገጾች",
      link_type: "ዓይነት",
      add_link: "አገናኝ ያክሉ",
      section_contact_form: "የመገናኛ ቅጽ",
      enable_contact_form: "በመገለጫዬ ላይ ቀላል የመገናኛ ቅጽ አንቃ",
      contact_email_label: "የመገናኛ መልእክቶችን ለመቀበል ኢሜይል",
      contact_email_placeholder: "email@example.com",
      contact_form_hint: "መልእክቶቹ የመጀመሪያ መተዋወቅ ብቻ ናቸው። የሕክምና መረጃ አይጠይቁ ወይም አያጋሩ።",
      pending_title: "መገለጫ ተልኳል — ለግምገማ በመጠባበቅ ላይ",
      pending_desc: "እናመሰግናለን። ከመታተሙ በፊት የኮንኪየን ሆይ አስተዳዳሪ መገለጫዎን ይገመግማል። መገለጫዎች በራስ-ሰር ይፋ አይደረጉም።",
      go_workspace: "ወደ የእኔ ቦታ ይሂዱ",
      select_areas: "መስኮችዎን ይምረጡ",
    },
    onboarding: {
      title: "የባለሙያ መገለጫዎን ይፍጠሩ",
      subtitle: "እድገትዎን በራስ-ሰር እናስቀምጣለን። በፈለጉ ጊዜ መውጣት እና መመለስ ይችላሉ።",
      contact_title: "የመገናኛ መረጃ",
      contact_email_label: "የመገናኛ ኢሜይል",
      contact_email_hint: "ግዴታ ነው። ከመለያዎ ኢሜይል የተለየ ሊሆን ይችላል።",
      use_contact_form: "በቅጽ አማካኝነት መልእክቶችን ይቀበሉ (ኢሜይልዎ ይፋ አይታይም)",
      phone_label: "ስልክ (አማራጭ)",
      phone_hint: "የአገር ኮድ ያካትቱ። ለምሳሌ፦ +57 300 123 4567",
      phone_public_label: "የስልክ ቁጥሬን ይፋ አሳይ",
      phone_public_hint: "በነባሪ ጠፍቷል። ካነቁት፣ ስልክዎ በይፋዊ መገለጫዎ ላይ ይታያል።",
      other_country_label: "ሌላ አገር",
      other_country_placeholder: "አገር ይፈልጉ እና ያክሉ…",
      other_country_hint: "የሚያገለግሏቸውን ተጨማሪ አገሮች ለማከል ከዝርዝሩ ይምረጡ።",
      links_title: "አገናኞች (አማራጭ)",
      website_label: "ድር ጣቢያ",
      booking_label: "የቀጠሮ አገናኝ",
      booking_hint: "ሌላ አገልግሎት የሚጠቀሙ ከሆነ የውጫዊ የቀን መቁጠሪያ አገናኝ።",
      video_label: "የቪዲዮ ጥሪ አገናኝ",
      availability_notes_label: "ስለ ተገኝነት ማስታወሻዎች (አማራጭ)",
      availability_notes_hint: "ስለ ተገኝነትዎ ማጋራት የሚፈልጉት ተጨማሪ መረጃ።",
      go_workspace: "ወደ የእኔ ቦታ ይሂዱ",
      stage_account: "መለያ",
      stage_identity: "የሙያ ማንነት",
      stage_experience: "ልምድ እና አቀራረብ",
      stage_services: "አገልግሎቶች እና ችሎታዎች",
      stage_profile: "መገለጫ",
      stage_availability: "ተገኝነት",
      stage_review: "ግምገማ",
      stage_submitted: "ተልኳል",
      step_of: "ደረጃ {n} ከ {total}",
      save_continue: "አስቀምጥ እና ቀጥል",
      save_exit: "አስቀምጥ እና ውጣ",
      back: "ተመለስ",
      draft_saved: "ረቂቅ ተቀምጧል",
      save_error: "ማስቀመጥ አልተቻለም። እንደገና ይሞክሩ።",
      choose_profession: "ሙያዎ ምንድን ነው?",
      choose_profession_hint: "በተሻለ የሚገልጽዎትን አማራጭ ይምረጡ። በመገለጫዎ ላይ በግልጽ ይታያል።",
      account_intro: "መሠረታዊ የመገናኛ እና የአካባቢ መረጃ።",
      identity_intro: "ሙያዎ፣ ማዕረግዎ እና ማስረጃዎችዎ።",
      credentials: "የሙያ ማስረጃዎች",
      credentials_hint: "እንደ ክሊኒካል ባለሙያ፣ ለማረጋገጥ የፈቃድ መረጃዎ ያስፈልገናል።",
      credential_type: "የማስረጃ / ምዝገባ ዓይነት",
      review_title: "ከመላክዎ በፊት መገለጫዎን ይገምግሙ",
      review_intro: "ሁሉም ነገር ትክክል መሆኑን ያረጋግጡ። ማንኛውንም ክፍል ማረም ይችላሉ።",
      incomplete_title: "አንዳንድ ግዴታ የሆኑ መረጃዎች ይጎድላሉ",
      incomplete_desc: "መገለጫዎን ለግምገማ ለመላክ ምልክት የተደረገባቸውን መስኮች ይሙሉ።",
      submit: "ለግምገማ ይላኩ",
      resubmit: "ለግምገማ እንደገና ይላኩ",
      not_provided: "አልተገለጸም",
      submitted_title: "መገለጫ ተልኳል! — ለግምገማ በመጠባበቅ ላይ",
      submitted_desc: "እናመሰግናለን። ከመታተሙ በፊት የኮንኪየን ሆይ አስተዳዳሪ መገለጫዎን ይገመግማል። ሁኔታው ሲቀየር ኢሜይል ይደርስዎታል።",
      resubmitted_desc: "እናመሰግናለን። ለውጦችዎን ተቀብለናል እና መገለጫዎ እንደገና ለግምገማ በመጠባበቅ ላይ ነው።",
      missing_full_name: "ሙሉ ስም",
      missing_profession: "ሙያ",
      missing_profession_other: "ሙያዎን ይግለጹ",
      missing_country: "አገር",
      missing_bio: "የሙያ የሕይወት ታሪክ",
      missing_years_experience: "የልምድ ዓመታት",
      missing_languages: "ቋንቋዎች",
      missing_engagement_types: "የሥራ ዓይነቶች",
      missing_connection_methods: "ቢያንስ አንድ የመገናኛ መንገድ",
      missing_license_number: "የፈቃድ ቁጥር",
      missing_license_org: "የሚሰጠው ድርጅት",
      missing_license_country: "የፈቃድ አገር",
      missing_expertise: "የልዩ ሙያ መስኮች",
      missing_who: "ከማን ጋር ይሠራሉ?",
      missing_services: "እንዴት ይሠራሉ?",
      missing_populations_served: "ሕዝቦች",
      missing_service_languages: "የሚያስተምሯቸው ቋንቋዎች",
      missing_contact_email: "የመገናኛ ኢሜይል",
      category_label: "የሙያ ምድብ",
      category_hint: "ሥራዎን በተሻለ የሚገልጸውን መስክ ይምረጡ።",
      profession_public_note: "ሙያዎ እና ልዩ ሙያዎችዎ በይፋዊ መገለጫዎ ላይ ይታያሉ።",
      qual_placeholder: "የምስክር ወረቀቶች፣ ስልጠና ወይም ተዛማጅ ልምድ…",
      qual_note: "ተዛማጅ ብቃቶችዎን ያጋሩ — እንደ ክሊኒካል ፈቃድ አይቆጠርም።",
      languages_you_teach: "የሚያስተምሯቸው ቋንቋዎች",
      specialties_label: "ልዩ ሙያዎች / ችሎታዎች",
      specialties_hint: "ማንን በምን መርዳት ይችላሉ?",
      specialty_add_placeholder: "ልዩ ሙያ ያክሉ…",
      add_btn: "ያክሉ",
      payment_info_note: "ይህ መረጃ ለማሳወቅ ብቻ ነው። ኮንኪየን ሆይ ክፍያ ወይም ሒሳብ አያስተናግድም።",
      no_matches: "ምንም አልተገኘም",
    },
    workspace: {
      title: "የእኔ ቦታ",
      profile: "የእኔ መገለጫ",
      links: "የእኔ አገናኞች",
      initiatives: "የእኔ ተነሳሽነቶች",
      availability: "ተገኝነት",
      no_profile_title: "እስካሁን መገለጫዎን አልፈጠሩም",
      no_profile_desc: "ከግምገማ በኋላ በማውጫው ላይ ለመታየት የባለሙያ መገለጫዎን ይፍጠሩ።",
      create_profile: "መገለጫዬን ፍጠር",
      status_pending: "መገለጫዎ በአስተዳዳሪ ለግምገማ በመጠባበቅ ላይ ነው።",
      status_verified: "መገለጫዎ ተረጋግጧል እና በማውጫው ላይ ይታያል።",
      status_rejected: "መገለጫዎ አልጸደቀም። አርትዕ አድርገው እንደገና መላክ ይችላሉ።",
      status_suspended: "መገለጫዎ ታግዷል። እባክዎ አስተዳደሩን ያግኙ።",
      no_initiatives: "እስካሁን በማንኛውም ተነሳሽነት አልተሳተፉም።",
      view_initiative: "ተነሳሽነት እይ",
      participations_all: "ሁሉም",
      participations_initiatives: "ተነሳሽነቶች",
      participations_opportunities: "ዕድሎች",
      profile_saved: "መገለጫ በተሳካ ሁኔታ ተቀምጧል።",
      links_saved: "አገናኞች ተዘምነዋል።",
      changes_banner_title: "ከመቀጠልዎ በፊት አንዳንድ ለውጦች ያስፈልጋሉ።",
      update_profile: "መገለጫ አዘምን",
      resubmit: "ለግምገማ እንደገና ይላኩ",
      status_changes: "አስተዳዳሪ በመገለጫዎ ላይ ለውጦችን ጠይቋል። ይገምግሙ፣ መረጃዎን ያዘምኑ እና እንደገና ይላኩ።",
      settings: "ቅንብሮች",
      status_draft: "መገለጫዎ ረቂቅ ነው። ለግምገማ ለመላክ ካቆሙበት ይቀጥሉ።",
      status_changes_short: "ለውጦች ተጠይቀዋል",
      draft_banner: "መገለጫዎን ለግምገማ ለመላክ ምዝገባዎን ያጠናቅቁ።",
      continue_onboarding: "ምዝገባ ቀጥል",
      requested_changes_label: "የተጠየቁ ለውጦች፦",
    },
    del: {
      section_title: "የአደጋ ቀጠና",
      pro_button: "የባለሙያ መገለጫ ሰርዝ",
      pro_desc: "ይህ የባለሙያ መገለጫዎን ይሰርዛል፣ የኮንኪየን ሆይ መለያዎን አይደለም። መግቢያዎ ይቀመጣል እና በኋላ አዲስ መገለጫ መፍጠር ይችላሉ።",
      confirm_title: "የባለሙያ መገለጫዎን በቋሚነት ይሰርዙ?",
      confirm_body: "የባለሙያ መገለጫዎ በኮንኪየን ሆይ ላይ መገኘቱ ይቆማል እና በአስተማማኝ መንገድ ሊሰረዙ የሚችሉ ተያያዥ መረጃዎች ይሰረዛሉ። ይህ እርምጃ መቀልበስ አይቻልም።",
      cancel: "ይቅር",
      confirm_action: "በቋሚነት ሰርዝ",
      success: "የባለሙያ መገለጫ ተሰርዟል።",
      blocked_title: "አሁን መሰረዝ አይቻልም",
      blocked_body: "ይህ መገለጫ መቀመጥ ያለበት ተያያዥ እንቅስቃሴ (ቀጠሮዎች፣ ተሳትፎዎች ወይም መልእክቶች) አለው። ታሪኩን ለመጠበቅ፣ መገለጫው በአሁኑ ጊዜ በቋሚነት ሊሰረዝ አይችልም።",
      error: "መገለጫውን መሰረዝ አልተቻለም። እንደገና ይሞክሩ።",
      admin_button: "መገለጫ ሰርዝ",
      admin_confirm_title: "ይህን የባለሙያ መገለጫ በቋሚነት ይሰርዙ?",
      admin_confirm_body: "መገለጫው እና በአስተማማኝ መንገድ ሊሰረዙ የሚችሉ ተያያዥ መረጃዎች ይሰረዛሉ። የተጠቃሚው የመግቢያ መለያ አይሰረዝም። ይህ እርምጃ መቀልበስ አይቻልም።",
      admin_success: "የባለሙያ መገለጫ ተሰርዟል።",
    },
    booking: {
      book_cta: "ቀጠሮ ይያዙ",
      agenda: "አጀንዳ",
      my_appts: "የእኔ ቀጠሮዎች",
      upcoming: "መጪ",
      past: "ያለፉ",
      settings: "የቀጠሮ ቅንብሮች",
      appointments: "ቀጠሮዎች",
      availability: "ተገኝነት",
      client: "ደንበኛ",
      reschedule: "እንደገና መድብ",
      reschedule_title: "ቀጠሮ እንደገና መድብ",
      choose_new_time: "አዲስ ሰዓት ይምረጡ",
      no_slots: "በዚያ ቀን ነፃ ሰዓት የለም።",
      rescheduled_ok: "ቀጠሮ እንደገና ተመድቧል",
      reschedule_err: "እንደገና መመደብ አልተቻለም",
      confirm_new_time: "አዲሱን ሰዓት አረጋግጥ",
      mark_completed: "ተጠናቋል",
      mark_no_show: "አልቀረበም",
      status_updated: "ሁኔታ ተዘምኗል",
      account_settings: "የመለያ ቅንብሮች",
      no_appts_psy: "እስካሁን ምንም ቀጠሮ የለዎትም",
      reminders_note: "ማስታወሻዎች ከ24 ሰዓት እና ከ3 ሰዓት በፊት በራስ-ሰር ይላካሉ።",
      status_accepting: "ቀጠሮዎችን እየተቀበለ ነው",
      status_limited: "ውስን ተገኝነት",
      status_not_accepting: "በአሁኑ ጊዜ ቀጠሮ አይቀበልም",
      no_slots_hint: "ነፃ ሰዓት ያላቸውን ቀናት ብቻ መምረጥ ይችላሉ።",
      settings_saved: "ቅንብሮች ተቀምጠዋል",
      settings_err: "ቅንብሮችን ማስቀመጥ አልተቻለም",
      your_timezone: "የእርስዎ የሰዓት ሰቅ",
      confirm_cancel: "ይህን ቀጠሮ ይሰርዙ?",
      cancelled_ok: "ቀጠሮ ተሰርዟል",
      cancel_err: "መሰረዝ አልተቻለም",
      update_err: "ማዘመን አልተቻለም",
      add_appt: "ቀጠሮ ጨምር",
      manual_tag: "በእጅ",
      st_confirmed: "የተረጋገጠ",
      st_cancelled: "የተሰረዘ",
      st_completed: "የተጠናቀቀ",
      st_no_show: "አልቀረበም",
      st_rescheduled: "እንደገና የተመደበ",
      enter_client_name: "የደንበኛውን ስም ያስገቡ",
      choose_date_time: "ቀን እና ሰዓት ይምረጡ",
      invalid_duration: "ልክ ያልሆነ ቆይታ",
      appt_rescheduled: "ቀጠሮ እንደገና ተመድቧል",
      appt_added: "ቀጠሮ ወደ አጀንዳዎ ታክሏል",
      save_appt_err: "ቀጠሮውን ማስቀመጥ አልተቻለም",
      reschedule_appt: "ቀጠሮ እንደገና መድብ",
      choose_new_date_time: "አዲስ ቀን እና ሰዓት ይምረጡ።",
      manual_desc: "ከመድረኩ ውጭ ለሚያገለግሉት ደንበኛ ቀጠሮ ይመዝግቡ። መለያ አያስፈልግም።",
      client_name: "የደንበኛ ስም",
      client_name_ph: "ለምሳሌ፦ የናሙና ደንበኛ",
      date: "ቀን",
      start_time: "የመጀመሪያ ሰዓት",
      duration_min: "ቆይታ (ደቂቃ)",
      type_title_opt: "ዓይነት / ርዕስ (አማራጭ)",
      type_title_ph: "ለምሳሌ፦ የክትትል ክፍለ ጊዜ",
      private_note_opt: "የግል ማስታወሻ (አማራጭ)",
      private_note_ph: "ይህን እርስዎ ብቻ ማየት ይችላሉ",
      client_email_opt: "የደንበኛ ኢሜይል (አማራጭ)",
      email_will_send: "ለደንበኛው ማረጋገጫ እና ማስታወሻዎች ይላካሉ።",
      email_internal: "ኢሜይል ከሌለ፣ ቀጠሮው ውስጣዊ ብቻ ነው (ለደንበኛው ማሳወቂያ የለም)።",
      email_language: "የኢሜይል ቋንቋ",
      email_lang_note: "ደንበኛው ኢሜይሎቹን በዚህ ቋንቋ ይቀበላል።",
      save_changes: "ለውጦችን አስቀምጥ",
      booked_ok: "ቀጠሮ ተይዟል!",
      slot_unavailable: "ያ ሰዓት ከአሁን በኋላ አይገኝም",
      appt_type: "የቀጠሮ ዓይነት",
      modality: "ዓይነት",
      choose_date: "ቀን ይምረጡ",
      your_local_time: "የእርስዎ የአካባቢ ሰዓት",
      no_times_day: "በዚያ ቀን ነፃ ሰዓት የለም።",
      continue: "ቀጥል",
      professional_time: "የባለሙያው ሰዓት",
      confirm_booking: "ቀጠሮ አረጋግጥ",
      pick_time_again: "እባክዎ ሰዓት እንደገና ይምረጡ።",
      back: "ተመለስ",
      appt_confirmed: "ቀጠሮዎ ተረጋግጧል።",
      confirmation_email_sent: "የማረጋገጫ ኢሜይል ልከንልዎታል።",
      create_account: "መለያ ይፍጠሩ",
      sign_in: "ይግቡ",
      account_needed: "ለመያዝ መለያ ያስፈልግዎታል። ክሊኒካል መረጃ አንጠይቅም።",
      full_name: "ሙሉ ስም",
      email: "ኢሜይል",
      password: "የይለፍ ቃል",
      phone_opt: "ስልክ (አማራጭ)",
      tz_autodetect: "በራስ-ሰር ተገኝቷል — እባክዎ ያረጋግጡ።",
      create_continue: "መለያ ፍጠር እና ቀጥል",
      current: "አሁን ያለው",
      no_appts_client: "እዚህ ምንም ቀጠሮ የለዎትም",
      find_professional: "ባለሙያ ፈልግ",
      add_to_calendar: "ወደ ቀን መቁጠሪያ ጨምር",
      book_again: "እንደገና ይያዙ",
      enable_booking: "በመገለጫዬ ላይ ቀጠሮ መያዝ አንቃ",
      avail_tz_note: "ተገኝነትዎ በአካባቢዎ ሰዓት ይገለጻል።",
      weekly_avail: "ሳምንታዊ ተገኝነት",
      unavailable: "አይገኝም",
      appt_types: "የቀጠሮ ዓይነቶች",
      add: "ጨምር",
      buffer_before: "ከበፊት ልዩነት (ደቂቃ)",
      buffer_after: "ከኋላ ልዩነት (ደቂቃ)",
      min_notice: "ዝቅተኛ ማሳወቂያ (ሰዓት)",
      booking_horizon: "የቀጠሮ ጊዜ ገደብ (ቀናት)",
      blocked_dates: "የታገዱ ቀናት",
      all_day: "ሙሉ ቀን",
      internal_note_priv: "ውስጣዊ ማስታወሻ (የግል)",
      type_label_ph: "መለያ (ለምሳሌ፦ ምክክር)",
      default_short: "ነባሪ",
      location_inperson: "አካባቢ (በአካል)",
      online_info: "የመስመር ላይ ክፍለ ጊዜ መረጃ",
      cancel_policy_opt: "የመሰረዝ መመሪያ (አማራጭ)",
      advance_reminder: "ቅድመ ማስታወሻ",
      sameday_reminder: "የዕለቱ ማስታወሻ",
      cal_event_title: "ቀጠሮ ከ",
    },
    initiatives: {
      title: "የድጋፍ ተነሳሽነቶች",
      subtitle: "ባለሙያዎች ጊዜያቸውን የሚያበረክቱባቸው የተደራጁ ጥረቶች።",
      description: "መግለጫ",
      is_opportunity_label: "ይህ የሙያ ዕድል ነው",
      category_sought: "የሚፈለገው የሙያ ምድብ",
      specialty_optional: "ስፔሻሊቲ (አማራጭ)",
      empty_title: "እስካሁን ተነሳሽነቶች የሉም",
      empty_desc: "የድጋፍ ተነሳሽነቶች ሲታተሙ እዚህ ይታያሉ።",
      goal: "የተሳትፎ ግብ",
      applicants: "አመልካቾች",
      confirmed: "የተረጋገጡ",
      remaining: "የቀሩ ቦታዎች",
      languages_needed: "የሚያስፈልጉ ቋንቋዎች",
      requirements: "የሙያ መስፈርቶች",
      organizer: "አዘጋጅ",
      location: "አካባቢ",
      dates: "ቀናት",
      participate: "ለመሳተፍ ያመልክቱ",
      participate_desc: "ለዚህ ተነሳሽነት የተወሰነ መረጃ ብቻ እንጠይቃለን።",
      p_availability: "አጠቃላይ ተገኝነትዎ",
      p_dates: "ሊሳተፉባቸው የሚችሉ ቀናት",
      p_format: "የመስመር ላይ / በአካል ተገኝነት",
      p_notes: "ለአዘጋጁ ማስታወሻዎች",
      request_sent: "የተሳትፎ ጥያቄዎ ተልኳል።",
      already_joined: "በዚህ ተነሳሽነት ለመሳተፍ አስቀድመው አመልክተዋል።",
      login_to_join: "ለመሳተፍ እንደ ባለሙያ ይግቡ።",
      need_profile: "ለመሳተፍ የባለሙያ መገለጫ ያስፈልግዎታል። በምዝገባው እንመራዎታለን።",
      no_participants: "እስካሁን የተሳትፎ ጥያቄዎች የሉም።",
      requires_online: "የመስመር ላይ ተገኝነት ይጠይቃል",
      requires_in_person: "በአካል ተገኝነት ይጠይቃል",
      format_label_display: "ዓይነት",
      online_and_in_person: "በመስመር ላይ እና በአካል",
      participation_closed: "በዚህ ተነሳሽነት መሳተፍ ተዘግቷል።",
      not_published: "ይህ ተነሳሽነት ገና ለተሳትፎ ክፍት አይደለም።",
      how_to_join: "እንዴት መሳተፍ?",
      share_initiative: "ተነሳሽነት አጋራ",
      share_whatsapp: "WhatsApp",
      share_email: "ኢሜይል",
      share_email_subject: "በኮንኪየን ሆይ ላይ ተነሳሽነት",
      share_email_intro: "ይህን የኮንኪየን ሆይ ተነሳሽነት አጋራዎታለሁ",
      share_native: "አጋራ…",
      add_to_calendar: "ወደ ቀን መቁጠሪያ ጨምር",
      request_pending: "ጥያቄዎ በግምገማ ላይ ነው።",
      request_confirmed: "በዚህ ተነሳሽነት ለመሳተፍ ተረጋግጠዋል!",
      request_declined: "ጥያቄዎ በዚህ ጊዜ አልተመረጠም።",
      full_badge: "ተነሳሽነቱ ሞልቷል",
      full_short: "ሞልቷል",
      full_note: "ይህ ተነሳሽነት የተሳትፎ ግቡን አሳክቷል።",
      reminder_text: "እንኳን ተመለሱ። በዚህ ተነሳሽነት ለመሳተፍ ጥያቄዎን ያጠናቅቁ።",
      joined_singular: "ባለሙያ ተቀላቅሏል",
      joined_plural: "ባለሙያዎች ተቀላቅለዋል",
      filters: "ማጣሪያዎች",
      search_placeholder: "ተነሳሽነቶችን ፈልግ…",
      f_location: "አገር ወይም አካባቢ",
      f_language: "የሚያስፈልግ ቋንቋ",
      f_status: "ሁኔታ",
      f_open: "ክፍት ቦታ ያለው",
      f_date_from: "ከ",
      f_date_to: "እስከ",
      clear_filters: "ማጣሪያዎችን አጽዳ",
      all_statuses: "ሁሉም",
      no_match_title: "ምንም ተነሳሽነት አልተዛመደም",
      no_match_desc: "ተጨማሪ ተነሳሽነቶችን ለማየት ማጣሪያዎችን ያስተካክሉ ወይም ያጽዱ።",
      join_intro: "በዚህ ተነሳሽነት እንደ ባለሙያ ይቀላቀሉ።",
      cta_login: "ይግቡ",
      cta_create_profile: "የባለሙያ መገለጫ ይፍጠሩ",
      cta_guest_note: "ለመሳተፍ ይግቡ ወይም የባለሙያ መገለጫዎን ይፍጠሩ።",
      pick_dates: "ቀን(ዎች) ይምረጡ",
      single_day: "አንድ ቀን",
      date_range: "የቀናት ክልል",
      clear_dates: "ቀናትን አጽዳ",
      category: "ምድብ",
      specialty: "ልዩ ሙያ",
      spots_remaining_one: "{n} ቦታ ቀርቷል",
      spots_remaining_other: "{n} ቦታዎች ቀርተዋል",
    },
    opportunities: {
      title: "የሙያ ዕድሎች",
      subtitle: "በድርጅቶች የታተሙ ክፍት የሙያ ዕድሎችን ያግኙ።",
      badge: "የሙያ ዕድል",
      empty_title: "እስካሁን ክፍት ዕድሎች የሉም",
      empty_desc: "ድርጅቶች የሙያ ዕድሎችን ሲያትሙ እዚህ ይታያሉ።",
      no_match_title: "ምንም ዕድል አልተዛመደም",
      no_match_desc: "ተጨማሪ ዕድሎችን ለማየት ማጣሪያዎችን ያስተካክሉ ወይም ያጽዱ።",
      search_placeholder: "ዕድሎችን ፈልግ…",
      filters: "ማጣሪያዎች",
      advanced: "የላቁ ማጣሪያዎች",
      clear_filters: "ማጣሪያዎችን አጽዳ",
      view_details: "ዝርዝሮችን እይ",
      results: "ዕድሎች",
      result: "ዕድል",
      open_status: "ክፍት",
      closed_status: "ተዘግቷል",
      full_status: "ቦታዎች ሞልተዋል",
      deadline_passed: "ጊዜው አልፏል",
      f_profession: "የሚያስፈልግ ሙያ",
      f_language: "የሚያስፈልግ ቋንቋ",
      f_location: "አገር ወይም አካባቢ",
      f_modality: "ዓይነት",
      f_engagement: "የሥራ ዓይነት",
      f_compensation: "ክፍያ",
      f_verified_required: "የተረጋገጡ ማስረጃዎች ይጠይቃል",
      f_experience: "የሚያስፈልግ ልምድ",
      f_crisis: "የችግር / የአደጋ ምላሽ",
      f_group: "የቡድን ሥራ",
      f_training: "ስልጠና / ዎርክሾፕ",
      f_organizational: "ድርጅታዊ ልምድ",
      f_deadline_before: "የመጨረሻ ቀን እስከ",
      f_open_only: "ክፍት ዕድሎች ብቻ",
      section_about: "ስለ ዕድሉ",
      section_org: "ድርጅት",
      section_requirements: "የሙያ መስፈርቶች",
      section_engagement: "የሥራ ዝርዝሮች",
      section_dates: "ቀናት",
      section_location: "አካባቢ እና ዓይነት",
      section_compensation: "ክፍያ",
      required_profession: "የሚያስፈልግ ሙያ",
      required_languages: "የሚያስፈልጉ ቋንቋዎች",
      engagement_type: "የሥራ ዓይነት",
      compensation_type: "ክፍያ",
      min_experience: "ዝቅተኛ ልምድ",
      professionals_needed: "የሚያስፈልጉ ባለሙያዎች",
      application_deadline: "የማመልከቻ የመጨረሻ ቀን",
      verified_required: "የተረጋገጡ ማስረጃዎች ይጠይቃል",
      no_specific: "ለዚህ ዕድል የተለየ መስፈርት የለም።",
      your_profile: "ከመገለጫዎ ጋር ንጽጽር",
      met: "ይህን መስፈርት ያሟላሉ",
      not_met: "ይህን መስፈርት አያሟሉም",
      compare_note: "ከመገለጫዎ ጋር ለማሳወቅ የቀረበ ንጽጽር። የመጨረሻ ውሳኔውን ድርጅቱ ያደርጋል።",
      profession_mismatch_title: "ሙያዎ አይዛመድም",
      profession_mismatch_desc: "ይህ ዕድል ሌላ ሙያ ይጠይቃል፣ ስለዚህ ማመልከት አይችሉም።",
      apply: "አመልክት",
      apply_intro: "ለዚህ የሙያ ዕድል ያመልክቱ።",
      applied_pending: "ማመልከቻዎ በግምገማ ላይ ነው።",
      applied_confirmed: "በዚህ ዕድል ተቀባይነት አግኝተዋል!",
      applied_declined: "ማመልከቻዎ በዚህ ጊዜ አልተመረጠም።",
      years: "ዓመታት",
      deadline_label: "የመጨረሻ ቀን",
      closed_note: "ይህ ዕድል ከአሁን በኋላ ማመልከቻ አይቀበልም።",
      req_languages_field: "የሚያስፈልጉ ቋንቋዎች",
      deadline_field: "የማመልከቻ የመጨረሻ ቀን",
    },
    inbox: {
      nav: "የገቢ መልእክት ሳጥን",
      title_prof: "የተቀበሉ ጥያቄዎች",
      title_org: "የተላኩ ጥያቄዎች",
      empty_prof: "እስካሁን ከድርጅቶች ጥያቄ አልተቀበሉም።",
      empty_org: "እስካሁን ለባለሙያዎች ጥያቄ አልላኩም።",
      sent_on: "ተልኳል",
      contact: "አድራሻ",
      location: "አካባቢ",
      modality: "ዓይነት",
      timeframe: "ቀን ወይም ጊዜ",
      language: "ቋንቋ",
      note: "ማስታወሻ",
      optional_note: "አማራጭ ማስታወሻ",
      note_placeholder: "ፍላጎት አለኝ። እባክዎ ስለ ተገኝነት እና ስፋት ለመነጋገር ያግኙኝ።",
      interested: "ፍላጎት አለኝ",
      decline: "አልቀበልም",
      close_inquiry: "ጥያቄ ዝጋ",
      view_opportunity: "ዕድል እይ",
      responded: "የእርስዎ ምላሽ",
      interested_sent: "ምላሽ ተልኳል",
      closed_toast: "ጥያቄ ተዘግቷል",
      closed_by_org: "ድርጅቱ ይህን ጥያቄ ዘግቷል።",
      do_not_share: "ሚስጥራዊ የክሊኒካል መረጃ ወይም የታካሚ ውሂብ አያጋሩ።",
      st_new: "አዲስ",
      st_viewed: "የታየ",
      st_interested: "ፍላጎት ያለው",
      st_declined: "ተቀባይነት ያላገኘ",
      st_closed: "የተዘጋ",
    },
    contact: {
      title: "መልእክት ይላኩ",
      desc: "ራስዎን በአጭሩ ያስተዋውቁ። ይህ ቅጽ ለመጀመሪያ ግንኙነት ብቻ ነው።",
      notice: "የሕክምና መረጃ፣ ምርመራዎች፣ የክሊኒካል ታሪኮች፣ የአደጋ ጊዜ መረጃ ወይም ሚስጥራዊ የጤና መረጃ አያካትቱ።",
      name: "የእርስዎ ስም",
      email: "የእርስዎ ኢሜይል",
      message: "አጭር መልእክት",
      send: "መልእክት ላክ",
      sending: "በመላክ ላይ…",
      sent: "መልእክትዎ ተልኳል።",
      error: "መልእክቱን መላክ አልተቻለም። እንደገና ይሞክሩ።",
    },
  },
};
